export default {
    admin: {
        title: 'Administratorin',
        superadmin: {
            title: 'Super Admin',
            edit: 'bearbeiten'
        },
        invite: {
            manage: 'Laden Sie Botschafter der Gemeinschaft ein',
            resend: 'wiederholen',
            resend_success: 'Einladung wurde ärgerlich',
        },
        events: {
            edit: {
                singular: 'Ereignis bearbeiten',
                plural: 'Ereignisse bearbeiten',
            },
            overview: 'Ereignisse',
        },
        organizations: {
            edit: {
                singular: 'Organisation und Marke bearbeiten',
                plural: 'Organisationen und Marken bearbeiten',
            },
            overview: 'Organisationen und Marken',
        },
        pages: {
            edit: {
                singular: 'Seite bearbeiten',
                plural: 'Seiten bearbeiten',
            },
            update: {
                success: 'Seite aktualisiert',
                singular: "Seite aktualisieren",
                title: "Titel",
                content: "Inhalt",
                update_success: "Seite erfolgreich aktualisiert"
            },
            overview: 'Seiten',
            title: 'Titel',
            content: 'Inhalt',
        },
        prices: {
            update: {
                success: 'Preise aktualisiert',
                singular: "Preise aktualisieren",
                title: "Titel",
                content: "Inhalt",
                update_success: "Die Preise erfolgreich aktualisiert"
            },
            success: 'erfolgreich kaufen',
        },
        users: {
            edit: {
                singular: 'Benutzer bearbeiten',
                plural: 'Benutzer bearbeiten',
            },
            active: 'Aktiv',
            passive: 'Passiv',
            overview: 'Benutzer',
            impersonate: {
                button: 'Identität annehmen',
                loading: 'Wird geladen...',
                error: 'Dieser Benutzer kann nicht imitiert werden.',
            },
        },
        // LA-194: the links Admin hands out so an organiser can submit
        // an event without having an account.
        submission_links: {
            title: 'Einreichungslinks',
            intro: 'Links, mit denen Veranstalter ohne Konto ein Event einreichen.',
            new: 'Neuer Link',
            new_hint: 'Erstelle einen Link, den du einem Veranstalter per WhatsApp oder E-Mail gibst.',
            create: 'Link erstellen',
            created: 'Link erstellt',
            search: 'Suchen',
            copy: 'Link kopieren',
            withdraw: 'Zurückziehen',
            reactivate: 'Reaktivieren',
            no_brand: 'Noch keine Brand',
            empty: 'Noch keine Links.',
            failed: 'Etwas ist schiefgelaufen.',
            has_submissions: 'Über diesen Link kamen bereits Einreichungen; ziehe ihn zurück statt ihn zu löschen.',
            delete_confirm: 'Link {code} löschen?',
            fields: {
                code: 'Code',
                label: 'Beschreibung',
                label_placeholder: 'z. B. Salsa Nights Rotterdam',
                brand: 'Brand',
                brand_placeholder: 'Brand suchen',
                brand_hint: 'Optional. Bestimmt, zu welcher Brand eine Einreichung gehört.',
                state: 'Status',
                submissions: 'Einreichungen',
                expires_at: 'Läuft ab am',
                max_submissions: 'Max. Einreichungen',
                contact_name: 'Kontakt',
                contact_email: 'E-Mail-Adresse',
            },
            states: {
                all: 'Alle',
                active: 'Aktiv',
                expired: 'Abgelaufen',
                withdrawn: 'Zurückgezogen',
                full: 'Voll',
            },
        },
        scraped_concepts: {
            title: 'Scraped Concepts', overview: 'Concepts Overview', edit: { title: 'Edit Concept' },
            columns: { source: 'Source', name: 'Name', dates: 'Dates', location: 'Location', organization: 'Organization', status: 'Status', brand_match: 'Marke', actions: 'Actions' },
            filters: { name: 'Event name', source: 'Source', status: 'Status', city: 'City', date_from: 'Date from', date_to: 'Date to', brand_status: 'Markenstatus' },

            brand_status: {
                unchecked: 'Noch nicht geprüft',
                unmatched: 'Noch nicht auf LatinMap',
                unmanaged: 'Vorhanden, nicht verwaltet',
                review: 'Prüfen',
                managed: 'Verwaltet',
            },
            match_signal: {
                email: 'über E-Mail gefunden',
                domain: 'über Website gefunden',
                name: 'über Namen gefunden',
                name_city: 'über Name + Stadt gefunden',
                fuzzy: 'ähnlicher Name — prüfen',
            },
            unlink_brand: 'Marke trennen',
            organization_unlinked: 'Marke getrennt',
            unlink_confirm: {
                title: 'Marke trennen?',
                submit: 'Ja, trennen',
                body: 'Die Verknüpfung zwischen "{event}" und der Marke "{brand}" entfernen?',
                note: 'Das Konzept bleibt in der Liste und kann mit einer anderen Marke verknüpft werden. Es wird nichts gelöscht.',
            },
            link_confirm: {
                title: 'Marke verknüpfen?',
                submit: 'Ja, verknüpfen',
                body: '"{event}" mit der Marke "{brand}" verknüpfen? Die Veranstaltung muss danach separat genehmigt werden.',
                signal: 'Gefunden:',
                warning_managed: 'Diese Marke wird aktiv von einem Professional verwaltet. Eine gescrapte Veranstaltung zu verknüpfen kann mit deren Arbeit kollidieren.',
                warning_review: 'Diese Zuordnung ist nicht sicher. Prüfe vor dem Verknüpfen, ob es wirklich dieselbe Marke ist.',
            },
            link_match: 'Diese Marke verknüpfen',
            refresh_matches: 'Zuordnungen aktualisieren',
            refresh_matches_help: 'Neu berechnen, zu welchen Marken die gescrapten Veranstalter gehören',
            matches_refreshed: 'Zuordnungen aktualisiert: {certain} sicher, {possible} zu prüfen',
            bulk: {
                selected: '{count} ausgewählt',
                link_matched: 'Zugeordnete Marke verknüpfen',
                approve: 'Genehmigen',
                reject: 'Ablehnen',
                clear: 'Auswahl aufheben',
                running: 'Wird ausgeführt...',
                select_all: 'Alle auf dieser Seite auswählen',
                select_one: '{name} auswählen',
                nothing_to_link: 'Keine sichere Zuordnung in der Auswahl',
                nothing_to_unlink: 'In der Auswahl ist keine Marke verknüpft',
                unlink: 'Trennen',
                result: '{succeeded} verarbeitet, {failed} übersprungen',
                confirm: {
                    title: 'Massenaktion bestätigen',
                    submit: 'Ja, fortfahren',
                    body_approve: '{count} Konzept(e) veröffentlichen? Konzepte ohne bestätigte oder sichere Marke werden übersprungen.',
                    body_reject: '{count} Konzept(e) ablehnen?',
                    body_unlink: 'Die Markenverknüpfung bei {count} Konzept(en) entfernen?',
                    unlink_skipped: '{skipped} aus der Auswahl werden übersprungen: dort ist keine Marke verknüpft.',
                    body_assign: '{count} Konzept(e) mit der gefundenen Marke verknüpfen? Die Veranstaltungen müssen danach separat genehmigt werden.',
                    assign_skipped: '{skipped} aus der Auswahl werden übersprungen: bereits verknüpft oder keine sichere Zuordnung.',
                    and_more: 'und {count} weitere',
                    assign_managed: '{count} dieser Marken werden aktiv von einem Professional verwaltet. Das Verknüpfen kann mit deren Arbeit kollidieren.',
                },
            },
            status_labels: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
            no_organization: 'No organization assigned', no_results: 'No concepts found', assign_first: 'Please assign an organization first',
            assign_organization: 'Assign Organization', search_organization: 'Search organization by name', current_organization: 'Currently assigned',
            organization_assigned: 'Organization assigned successfully', approve: 'Approve', reject: 'Reject',
            approved_success: 'Concept approved and event created', rejected_success: 'Concept rejected', approve_error: 'Failed to approve',
            save_success: 'Concept saved', scraped_at: 'Scraped at', view_source: 'View source', photos: 'Photos', admin_notes: 'Admin notes',
            reject_confirm: { title: 'Reject Concept', body: 'Are you sure you want to reject this concept?', submit: 'Reject' },
            search_btn: 'Search',
            back: 'Back',
            missing_fields: 'Please fill in the required fields',
            scraping: 'Scraping',
            scrape_result: 'Fetched {fetched}, created {created}, skipped {skipped}, errors {errors}',
        },
        report: {
            details: 'Details:',
            reported: 'Berichtet von:',
            suspended_at: 'suspendiert bei:',
            email: 'E-Mail:',
            phonenumber: 'Telefonnummer',
            message: 'Nachricht:',
            singular: 'Bericht',
            plural: 'Berichte',
            reportables: {
                event: 'Ereignisse',
                organization: 'Organisationen',
            },
            status: {
                submitted: 'eingereicht',
                under_review: 'in Prüfung',
                resolved: 'gelöst',
                no_issue: 'kein Problem',
            },
            reportables_by_type: {
                event: 'Ereignis',
                organisation: 'Organisationen und Marken',
                user: "Benutzerin",
                created_by: 'erstellt von',
                report_by: 'Bericht von',
                ip_adress: 'IP-Anzeige',
                reason: 'Grund',
                description: 'Beschreibung',
                empty: 'leer',
            },
            no_reports: 'Keine Berichte gefunden',
        },
        lead: {
            singular: 'führen',
            plural: {
                event: 'Event Lead',
                organization: 'Markenleiterin'
            }
        },
        block_user: {
            plural: 'Benutzer blockieren',

            title: 'BLOCKED',
            description: 'Ihr Konto wurde blockiert, Sie haben keinen Zugriff mehr auf die Plattform.'
        },
        setting: {
            plural: 'Einstellungen',
            reset: {
                warning: {
                    title: 'Setzen Sie alle Einstellungen im Administrator zurück.',
                    body: 'Sind Sie sicher, dass Sie alle Einstellungen zurücksetzen möchten?'
                }
            }
        },
        permissions: {
            plural: 'Berechtigungen',
            levels: {
                'level-1': 'Super Admin',
                'level-2': 'Administratorin',
                'level-3': 'Botschafterin',
                'level-4': 'Premium -Mitglied',
                'level-5': 'professionelles Mitglied',
                'level-6': 'Mitglied',
            },
            no_users_with_role: 'Es gibt keine Benutzer mit dieser Rolle.',
            rights: {
                'create-organization-on-behalf-of-other-user': 'Erstellen Sie eine Organisation im Namen anderer Benutzer',
                'latinmap-verify': 'Gewähren Sie LatinMap -Verifizierung der Status',
                invite: {
                    'level-3': 'Laden Sie Botschafter der Gemeinschaft ein',
                },
                reports: {
                    view: 'Berichte anzeigen',
                    delete: {
                        any: 'einen Bericht löschen',
                    },
                    update: 'Berichtsstatus aktualisieren',
                    export: 'Exportberichte',
                },
                events: {
                    create: 'Ereignisse erstellen',
                    view: 'Ereignisse anzeigen',
                    update: {
                        any: 'Aktualisieren Sie jedes Ereignis',
                        own: 'eigene Ereignisse aktualisieren',
                    },
                    delete: {
                        any: 'jede Veranstaltung löschen',
                        own: 'Ereignisse löschen',
                    },
                    publish: 'Veranstaltungen veröffentlichen',
                    unpublish: 'unveröffentlichte Ereignisse',
                    ownership: {
                        own: 'Eigentum an eigenen Ereignissen ändern',
                        any: 'Ändern Sie das Eigentum an einer Veranstaltung',
                    },
                    ticketshop: {
                        enable: 'Ticketshop aktivieren',
                    },
                },
                organisations: {
                    create: 'Erstellen Sie Organisationen und Marken',
                    update: {
                        any: 'Aktualisieren Sie Organisationen und Marken',
                        own: 'Aktualisieren Sie eigene Organisationen und Marken',
                    },
                    delete: {
                        any: 'Löschen Sie alle Organisationen und Marken',
                        own: 'eigene Organisationen und Marken löschen',
                    },
                    ownership: {
                        own: 'Ändern Sie das Eigentum an eigenen Organisationen und Marken',
                        any: 'Ändern Sie das Eigentum an Organisationen und Marken',
                    },
                },
                users: {
                    edit: 'Benutzer bearbeiten',
                },
                leads: {
                    view: 'Ansicht Leads',
                    delete: 'Leads löschen',
                },
                transfer_requests: {
                    view: 'Übertragungsanfragen anzeigen',
                    approve: 'Übertragungsanfragen genehmigen',
                }
            }
        },
        dance_styles: {
            title: 'Tanzstile',
            singular: 'Tanzstil',
            create: {
                singular: 'Tanzstil erstellen',
            },
            edit: {
                singular: 'Tanzstil bearbeiten',
                plural: 'Tanzstile bearbeiten',
            },
            delete: {
                title: 'Tanzstil löschen?',
                singular: 'löschen',
                cancel: 'stornieren',
                confirmation: 'Dieser Tanzstil hat Untertanzstile.',
                affected: 'Dieser Tanzstil wird in {event_count} -Events und {organisation_count} -Indiaterations verwendet.',
                label: 'Tanzstil löschen',
                placeholder: 'Geben Sie hier "{keyword}" ein und senden Sie es ab, um diesen Tanzstil zu entfernen.',
            },
            sub_dance_style: 'Untertanzstil',
            is_favorite: 'ist favorit',
        },
        music_styles: {
            title: 'Musikstile',
            singular: 'Musikstil',
            create: {
                singular: 'Musikstil erstellen',
            },
            edit: {
                singular: 'Musikstil bearbeiten',
                plural: 'Musikstile bearbeiten',
            },
            delete: {
                title: 'Musikstil löschen?',
                singular: 'löschen',
                cancel: 'stornieren',
                confirmation: 'Dieser Musikstil hat Submusikstile.',
                affected: 'Dieser Musikstil wird in {event_count} -Ergnen und {organisation_count} -Gerichten verwendet.',
                label: 'Musikstil löschen',
                placeholder: 'Geben Sie hier "{keyword}" ein und senden Sie es ab, um diesen Musikstil zu entfernen.',
                substyles: 'Dieser Musikstil hat submusiker Stile.',
            },
            sub_dance_style: 'Untertanzstil',
            sub_music_style: 'Submusikstil',
            is_favorite: 'ist favorit',
        },
        featuredEvent: 'Ausgewähltes Ereignis',
        event_types: {
            edit: {
                plural: 'Ereignisarten bearbeiten',
            }
        },
        brand_types: {
            edit: {
                plural: 'Brandtypen bearbeiten',
            }
        },
        prof_financial_title: 'Finanzzentrum',
        modoration:
        {
            title: 'Mäßigung',
        },
        official_brands: 'offical brands',

        export: {
            overview: {
                title: 'Exportieren und Übertragungen',
                subtitle: 'Exportieren Sie alle Organisationen, für jede Organisation wird ein Übertragungsverbindungsverbindung generiert.'
            },
            create: 'Export erstellen',
            copied_link: 'Link kopiert',
            take_ownership: 'Eigentum übernehmen',
            validate_phone: 'Um diese Organisation zu übernehmen, müssen Sie zunächst Ihre Telefonnummer validieren, dies kann hier unten erfolgen:',
            require_login: 'Um diese Organisation zu übernehmen, müssen Sie sich zunächst anmelden oder ein Konto erstellen, dies kann hier unten erfolgen:',
            to_login: 'sich anmelden',
            messages: {
                opened: 'Ihr Transferlink wurde erfolgreich aktiviert, Sie haben 30 Tage Zeit, um den Prozess abzuschließen.',
                continue: 'Ihr Transferlink wurde erfolgreich wiedereröffnet. Beenden Sie bitte den Übertragungsprozess.',
                no_key: 'Es wurde kein Schlüssel zur Verfügung gestellt. Wenn Sie die Seite aktualisiert haben, sollten Sie den ursprünglichen Link erneut öffnen.',
                not_exists: 'Derzeit gibt es keinen Übertragungsverbindungslink für diese Organisation.',
                unauthorized: "Sie sind nicht berechtigt, diese Organisationsübertragung zu akzeptieren.",
                expired: 'Dieser Link ist abgelaufen.',
                already_completed: 'Dieser Link wurde bereits abgeschlossen und kann nicht mehr verwendet werden.',
                transferred: 'Die Organisation wurde erfolgreich übertragen.'
            },
            warning: {
                title: 'Übertragungsverbindung löschen',
                body: 'Sind Sie sicher, dass Sie diesen Übertragungslink löschen möchten?'
            },
            status: {
                no_action: 'nicht übertragen',
                opened: 'geöffnet',
                completed: 'übertragen',
                expired: 'Abgelaufen'
            }
        },
        duplications: 'Duplikationen',
        suspend_toggle: {
            warning: {
                title: 'Federung umschalten',
                body: 'Sind Sie sicher, dass Sie die Aussetzung davon ändern möchten?'
            }
        },
        take_offline: {
            warning: {
                title: 'offline machen',
                body: 'Sind Sie sicher, dass Sie dies offline machen möchten, es wird für Benutzer nicht mehr sichtbar sein.'
            }
        },
        bring_online: {
            warning: {
                title: 'Online bringen',
                body: 'Sind Sie sicher, dass Sie dies online bringen möchten, es wird für Benutzer sichtbar sein.'
            }
        },
        'carousel-image': {
            plural: "Karussellbilder",
            overview: {
                title: "Karussellbilder",
                subtitle: "Verwalten Sie die Karussellbilder auf der Startseite."
            },
            create: {
                singular: "Karussellbild erstellen",
                success: "Karussellbild erfolgreich erstellt",
                error: "Fehler beim Erstellen des Karussellbilds"
            },
            delete: {
                success: "Karussellbild erfolgreich gelöscht",
                error: "Fehler beim Löschen des Karussellbilds"
            },
            image: "Bild",
            visibility: 'Sekunden sichtbar',
            title: "Titel",
            order_by: "Sortieren nach",
            warning: {
                body: "Sind Sie sicher, dass Sie dieses Karussellbild löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
                title: "Karussellbild löschen"
            },
        },
        'beta-feature': {
            plural: 'Beta -Funktionen',
            overview: {
                title: 'Beta -Funktionen',
                subtitle: 'Verwalten Sie die Beta -Funktionen auf der Plattform.',
                success: 'Beta -Funktion erfolgreich aktualisiert',
                error: 'Fehler beim Aktualisieren der Beta -Funktion',
            },
            key: 'Schlüssel',
            name: 'Name',
            description: 'Beschreibung',
            visible_to_admins: 'sichtbar für Administratoren',
            visible_to_users: 'für Benutzer sichtbar',
        }
    },
    nav_headers: {
        agenda: {
            label: 'Latin Agenda',
            options: {
                all_events: 'Alle Ereignisse',
                latin_festivals_and_congresses: 'Latin Feste und Kongresse',
                latin_parties_and_socials: 'Latin Parteien und Soziales'
            }
        },
        dance_schools: {
            label: 'Latin Tanzschulen',
            options: {
                dance_schools: 'Tanzschulen',
                try_outs_and_start_courses: 'Probieren Sie Outs und Beginnen Sie Kurse',
                workshops_and_bootcamps: 'Workshops und Bootcamps',
                about_the_latin_dance_scene: 'Über die Latin Tanzszene'
            }
        },
        community: {
            label: 'Latin Gemeinschaft',
            options: {
                teachers: 'Lehrer',
                show_performers_and_teams: 'Showkünstler und Teams',
                djs: 'DJs',
                live_bands: 'Live -Bands',
                media_photo_video: 'Medien, Foto, Video',
                mcs: 'MCs'
            }
        },
        dancewear_and_shoes: {
            label: 'Latin Tanzkleidung und Schuhe',
            options: {
                dancewear_and_shoes: 'Tanzkleidung und Schuhe'
            }
        },
        for_professionals: {
            label: 'Für Profis',
            options: {
                create_a_brand: 'So erstellen Sie eine Marke',
                create_an_event: 'So erstellen Sie eine Veranstaltung',
                promote_your_event: 'So fördern Sie Ihre Veranstaltung',
                professional_account_verification: 'Professionelle Kontoüberprüfung'
            }
        },
        join: {
            label: 'Treten Sie LatinMap bei',
            options: {
                create_a_brand_or_organization: 'Erstellen Sie eine Marke oder Organisation',
                become_an_ambassador: 'Werden Sie ein Botschafter'
            }
        },
        manage_and_promote: {
            label: 'Verwalten und Fördern',
            options: {
                my_events: 'Meine Ereignisse',
                promote_your_event: 'Werben Sie für Ihre Veranstaltung'
            }
        }
    },
    impersonation: {
        banner: 'Sie sehen als {name}',
        stop: 'Identitätsübernahme beenden',
    },
    menu_headers: {
        general_title: 'allgemein',
        orders_title: 'Meine Bestellungen',
        settings_title: 'Einstellungen',
        professional_title: 'Professional',
        prof_financial_title: 'Mein Finanzzentrum',
        special_access_title: 'besonderer Zugang',
        community_dashboard_title: 'Mein Botschafter des Community -Dashboards',
        session_title: 'Sitzung',
    },
    account: {
        organization_settings_title: 'Organisation Einstellungen',
        selected_organization: 'Ausgewählte Organisation',
        my_events: 'meine Ereignisse',
        role: 'Rolle',
        dashboard: "Armaturenbrett",
        default_filters: "meine Suche",
        favorites: "Favoritinnen",
        login: "Login",
        logout: "Abmelden",
        sign_in: "anmelden",
        sign_up: "Melden Sie sich an",
        email_address: "E-Mail-Adresse",
        password: "Passwort",
        password_repeat: "Passwort wiederholen",
        password_reset: "Passwort zurücksetzen",
        password_forgot: "Passwort vergessen",
        reset_password: "Passwort zurücksetzen",
        current_password: "Aktuelles Passwort",
        change_password: "Kennwort ändern",
        new_password: "Neues Passwort",
        password_reset_success: "Passwort zurücksetzen erfolgreich",
        forgot_password: "Passwort vergessen",
        not_a_member: "kein Mitglied",
        i_already_have_an_account: "Ich habe bereits ein Konto",
        i_accept_the: "Ich akzeptiere die",
        terms_and_conditions: "Geschäftsbedingungen",
        first_name: "Vorname",
        last_name: "Nachname",
        postal_code: "Postleitzahl",
        street_number: "Straßennummer",
        city: "Stadt",
        country: "Land",
        preferred_language: "Bevorzugte Sprache",
        date_of_birth: "Geburtsdatum",
        create: "Benutzerkonto erstellen",
        my_account: "mein Konto",
        my_professional_dashboard: "Mein professionelles Dashboard",
        ambassador_dashboard: "Botschafter Dashboard",
        my_organisations: "Meine Organisationen und Marken",
        my_organisations_description: "Verwalten Sie Ihre Organisationen und Marken",
        singular: "Konto",
        phone: "Telefonnummer",
        phone_verification_token: "Telefonüberprüfungs -Token",
        name: "Name",
        user_name: "Benutzername",
        resend_verification: "Überprüfung wiedergeben",
        update_error: 'Das Aktualisieren Ihres Kontos ist fehlgeschlagen.',
        myLatinmap: "Meine LatinMap",
        dancerprofile: "Mein Tänzerprofil",
        orders: 'Meine Bestellungen',
        phone_verification: 'Telefonüberprüfung',
        submitted_leads: 'Meine eingereichten Leads',
        settings: 'Einstellungen',
        switch: 'Zu Marke/Organisation wechseln',
        beta_features: 'Beta -Funktionen',
        gender: {
            singular: "Geschlecht",
            male: "männlich",
            female: "weiblich",
            other: "andere",
        },
        profile: {
            title: 'Profil',
            description: 'Verwalten Sie Ihre Profilinformationen, ändern Sie Ihr Passwort und mehr.',
        },
        remove: {
            label: 'Konto entfernen',
            placeholder: 'Geben Sie hier "delete" ein und senden Sie es ab, um Ihr Konto zu löschen.',
            admin_placeholder: 'Geben Sie hier "delete" ein und senden Sie die Aktion ab, um dieses Konto zu entfernen.',
            safeword: 'löschen',
            description: 'Dadurch werden Ihr Konto und alle zugehörigen Daten entfernt.',
        },
        favorites: {
            title: 'Favoritinnen',
            description: 'Ihre Lieblingsveranstaltungen, Tanzschulen usw.',
            no_favorites: 'Sie haben noch keine Favoriten in dieser Kategorie',
            plurals: {
                event: 'Ereignisse',
                dancer: 'Tänzer',
                dj: 'DJs',
                media: 'Medien',
                brand: 'Tanzschuhe, Kleidung, Laden',
                school: 'Tanzschulen',
                venue: 'Veranstaltungsorte',
                club: "Verein",
                teacher: "Lehrerin",
                show_performers_and_teams: "Showkünstler und Teams",
                performer: "Künstlerin",
                mc: "MC",
                latin_music: "lateinische Musik",
                event_organizer: "Veranstalter",
                organization: 'Organisationen und Marken',
            },
        },
        likes: {
            title: 'mag',
            description: 'Ihre gemochten Veranstaltungen, Tanzschulen usw.',
            no_likes: 'Sie haben noch keine Vorlieben in dieser Kategorie',
            plurals: {
                event: 'Ereignisse',
                dancer: 'Tänzer',
                dj: 'DJs',
                media: 'Medien (Foto, Video, Videobearbeitung)',
                brand: 'Tanzschuhe, Kleidung, Laden',
                school: 'Tanzschulen',
                venue: 'Veranstaltungsorte',
                club: "Verein",
                teacher: "Lehrerin",
                show_performers_and_teams: "Showkünstler und Teams",
                performer: "Künstlerin",
                mc: "MC",
                latin_music: "lateinische Musik",
                event_organizer: "Veranstalter",
                organization: 'Organisationen und Marken',
            },
        },
        verification: {
            phone: {
                description: "Eine Telefonüberprüfung ist erforderlich, um die Sicherheit und Authentizität von Benutzern zu gewährleisten, die auf das „professionelle“ Dashboard zugreifen.",
                not_verified: 'Ihre Telefonnummer wird nicht überprüft.',
                send_verification_text: 'Überprüfungstext senden',
                sent: 'Überprüftext gesendet',
                verified: 'Ihre Telefonnummer wird überprüft.',
                verify: 'Überprüfen Sie die Telefonnummer',
            },
        },

    },
    dashboard: {
        title: "Armaturenbrett",
        welcome: "Willkommen",
    },
    organizations: {
        organization_saved: 'Organisation gespeichert',
        containing_emoji_error: 'Emojis sind im Namen nicht zulässig. Verwenden Sie alphanumerische Zeichen oder zulässige Sonderzeichen.',
        invalid_character_error: 'Der Name enthält ein ungültiges Zeichen. Verwenden Sie alphanumerische Zeichen oder zulässige Sonderzeichen.\nUngültige Zeichen: ',
        overview: {
            filters: {
                option_labels: {
                    favorites: {
                        all: 'alle',
                    },
                    organization_type: {
                        all: 'alle',
                        dance_schools: 'Tanzschulen',
                        organizers: 'Organisatorinnen',
                        artists: 'Lehrer und Künstler',
                        disk_jockeys: 'DJs',
                    }
                }
            },
            no_results: {
                title: 'Keine Organisationen gefunden',
                subtitle: 'Keine Organisationen für die ausgewählten Filter gefunden.'
            },
        },
        transfers: {
            overview: {
                title: 'Transfers',
                subtitle: 'Verwalten Sie das Eigentum Ihrer Organisationen',
                incoming_transfers: 'eingehende Übertragungen',
                outgoing_transfers: 'Ausgangsübertragung',
                request: 'Anfrage',
                offer: 'Angebot',
                event: 'Ereignis',
                organization: 'Organisation',
            },
            status: {
                approved: 'Übertragung akzeptiert',
                pending: 'ausstehend',
                rejected: 'Übertragung verringerte sich'
            },
            create: {
                title: 'Eigentum übertragen',
                organization: 'Organisation',
                description: 'Übertragen Sie das Eigentum Ihrer Organisation auf einen anderen Benutzer.',
                reason: 'Grund',
                transfer_to: 'Übertragung auf (E -Mail)',
                transfer: 'überweisen',
                warning: 'Sobald die Übertragung akzeptiert wird, wird das Eigentum an der Organisation an den neuen Eigentümer übertragen.',
            }
        },
        remove: {
            label: 'Organisation Entfernen',
            description: 'Diese Organisation und alle zugehörigen Daten dauerhaft löschen.',
            success: 'Organisation erfolgreich gelöscht',
            error: 'Organisation konnte nicht gelöscht werden'
        },
        transactions: {
            overview: {
                title: 'Transaktionen',
                subtitle: 'Verwalten Sie die Transaktionen Ihrer Organisationen und Marken',
            }
        },
        create: 'Organisation erstellen',
        is_public_options: {
            private: 'Privat',
            public: 'öffentlich',
            private_warning: 'Ihre Organisation ist mit diesem Status online nicht sichtbar.'
        },
        offline_preview: 'Diese Organisation ist offline und nur als Vorschau sichtbar.',
    },
    organization: {
        accepts_posts_on_behalf: 'LatinMap darf unsere Veranstaltungen hinzufügen',
        accepts_posts_on_behalf_help: 'Wenn unsere Marke ruht, darf LatinMap öffentlich angekündigte Veranstaltungen unter unserem Namen hinzufügen. Sie sind deutlich gekennzeichnet und du kannst sie jederzeit bearbeiten oder entfernen.',
        'on-behalf-of': 'im Namen von',
        'on-behalf': {
            none: 'Wählen Sie Ihre Option aus',
            me: 'Ich vertrete diese Marke',
            other: 'Als Vertreter der Marke',
            noone: 'Als Botschafter von LatinMap',
        },
        featured: {
            title: 'Ausgewählte Tanzschulen',
            subtitle: 'Einige der vorgestellten Tanzakademien mit Tanzkurs mit Tanzkursen sind jetzt erhältlich.',
        },
        my_favorites: {
            title: 'meine Favoriten',
        },
        edit: {
            public_information: 'Information',
            customers: 'Kunden',
            events: 'Ereignisse',
            tickets: 'Tickets',
            authorized_person: 'autorisierte Personen',
        },
        organization_detail: {
            involved: 'beteiligt',
            verification_status: {
                verified: 'verifiziert',
                not_verified: 'noch nicht verifiziert',
            }
        },
        account: {
            title: "Konto",
            description: "Verwalten Sie Ihre Kontoinformationen für das professionelle Dashboard.",
            description_not_verified: "Bitte überprüfen Sie die Telefonnummer, um das professionelle Dashboard zu verwenden.",
        },
        transfer: {
            title: 'Eigentum übertragen',
            description: 'Möchten Sie das Eigentum an dieser Organisation anfordern?',
            what: 'Was wird angeboten?',
            submit: 'Anfrage senden',
            name: 'Name',
            location: 'Standort',
            email: 'E-Mail',
            reason: 'Grund',
            organization: 'Organisation und Marke',
            errors: {
                nameRequired: 'Name ist erforderlich.',
                emailRequired: 'E -Mail ist erforderlich.',
                reasonRequired: 'Grund ist erforderlich.'
            },
            succesfully_sent: 'Die Übertragungsanfrage wurde erfolgreich gesendet.',
            error_occurred: 'Etwas lief schief.',
            noOrganisation: 'Sie haben noch keine Organisationen.'
        },
        title: "Organisation",
        is_public: 'ist öffentlich',
        publicly_visible: 'öffentlich sichtbar',
        change_organization: "Organisation ändern",
        create: "Organisation erstellen",
        name: "Name",
        name_without_dj: "Name (ohne 'dj')",
        dj_name_tooltip: "Geben Sie nur den Namen ein. 'DJ' wird automatisch hinzugefügt",
        email: "E-Mail",
        phone: "Telefonnummer",
        phone_verification_token: "Telefonüberprüfungs -Token",
        country: "Land",
        city: "Stadt",
        street: "Straße",
        street_number: "Straßennummer",
        postal_code: "Postleitzahl",
        type: "Typ",
        question: "Ihre Organisation?",
        types: {
            event: 'Ereignis',
            dancer: "Tänzerin",
            latin_music: "lateinische Musik",
            performer: "Künstlerin",
            teacher: "Lehrerin",
            show_performers_and_teams: "Showkünstler und Teams",
            dj: "DJ",
            mc: "MC",
            media: "Medien (Foto, Video, Videobearbeitung)",
            brand: "Tanzschuhe, Kleidung, Laden",
            event_organizer: "Veranstalter",
            school: "Tanzschule",
            live_music: "Live -Band/Musik",
            venue: "Veranstaltungsort",
        },
        short_description: "Kurzbeschreibung",
        long_description: "lange Beschreibung",
        photos: "Fotos",
        dance_styles: "Tanzstile",
        music_styles: "Musikstile",
        my_brands: "meine Marken",
        my_brands_description: "Verwalten Sie Ihre Marken",
        overview: {
            title: 'Tanzschulen',
            subtitle: 'Finden Sie die besten Tanzschulen in Ihrer Nähe.',
            filters: {
                organization_name: 'Organisationsname',
                dance_styles: 'Tanzstile',
                postal_code: 'Postleitzahl',
                nearby_range: 'In der Nähe der Postleitzahl Vorschläge Bereiche Range',
                nearby: 'Vorschläge in der Nähe',
                location: 'Wo',
                favorites: 'Favoritinnen',
                country_codes: 'Ländercodes',
                music_styles: 'Musikstile',
                ambassadors: 'Botschafter',
                slidertooltip: '<p><strong> Der Bereich Slider passt die Ziffern der eingegebenen Postleitzahl an, um den Suchbereich zu erweitern.',
            },
            organizers: {
                title: 'Organisatorinnen',
                subtitle: 'Finden Sie die besten Organisatoren in Ihrer Nähe.',
            },
            artists: {
                title: 'Lehrer und Künstler',
                subtitle: 'Finden Sie die besten Künstler in Ihrer Nähe.',
            },
            dance_schools: {
                title: 'Tanzschulen',
                subtitle: 'Finden Sie die besten Tanzschulen in Ihrer Nähe.',
            },
            disk_jockeys: {
                title: 'DJs',
                subtitle: 'Finden Sie die besten DJs in Ihrer Nähe. Genießen Sie die besten Events und Festivals.',
            },
            show_performers_and_teams: {
                title: 'Showkünstler und Teams',
                subtitle: 'Finden Sie die besten Performer in Ihrer Nähe.',
            },
            teacher: {
                title: 'Lehrer',
                subtitle: 'Finden Sie die besten Lehrer in Ihrer Nähe.',
            },
            mcs: {
                title: "MCs",
                subtitle: 'Finden Sie die besten MCs in Ihrer Nähe.',
            },
            live_music: {
                title: "Live -Bands/Musik",
                subtitle: 'Finden Sie die besten Live -Bands und Musik in Ihrer Nähe.',
            },
            live_performer: {
                title: "Live -Performer",
                subtitle: 'Finden Sie die besten Live -Darsteller in Ihrer Nähe.',
            },
            performer: {
                title: "Künstlerin",
                subtitle:
                    "Finden Sie die besten Live-Künstler in Ihrer Nähe. Genießen Sie die besten Events und Festivals."
            },
            media: {
                title: "Medien (Foto, Video, Videobearbeitung)",
                subtitle: 'Finden Sie die besten Fotografen und Videografen in Ihrer Nähe.',
            },
            brand: {
                title: "Tanzschuhe, Kleidung, Laden",
                subtitle: 'Finden Sie die besten Tanzschuhe und Kleidung in Ihrer Nähe.',
            },
        },
        artists: {
            title: 'Lehrer und Künstler',
        },
        teacher: {
            title: 'Lehrer',
        },
        performer: {
            title: 'Darsteller'
        },
        show_performers_and_teams: {
            title: 'Showkünstler und Teams',
        },
        dance_schools: {
            title: 'Tanzschulen',
        },
        disk_jockeys: {
            title: 'DJs',
        },
        organizers: {
            title: 'Organisatorinnen',
        },
        manage_authorized_people: {
            title: 'Autorisierte Personen verwalten',
            description: 'Verwalte die autorisierten Personen der Organisationen, deren Eigentümer du bist. Autorisierte Personen können deine Organisation und Veranstaltungen verwalten.'
        },
        authorized_people: {
            title: 'Autorisierte Personen',
            description: 'Verwalten Sie die autorisierten Personen Ihrer Organisationen. Autorisierte Personen können Ihre Organisation und Veranstaltungen verwalten.',
            create: 'Autorisierte Person erstellen',
            edit: 'Autorisierte Person bearbeiten',
            overview: 'Autorisierte Personen',
            not_found: 'Keine autorisierten Personen gefunden',
        },
        mcs: {
            title: "MCs",
        },
        live_music: {
            title: "Live -Bands/Musik",
        },
        live_performer: {
            title: "Live -Darsteller",
        },
        media: {
            title: "Medien (Foto, Video, Videobearbeitung)",
        },
        brand: {
            title: "Tanzschuhe, Kleidung, Laden",
        },
        email_authorized: 'Geben Sie eine vorhandene E -Mail -Adresse ein.',
    },
    ambassador: {
        profile: "Profil",
        my_brands: "meine Marken",
        verification: {
            phone: {
                description: "Eine Telefonüberprüfung ist erforderlich, um die Sicherheit und Authentizität von Benutzern zu gewährleisten, die auf das Dashboard „Botschafter“ zugreifen."
            }
        }
    },
    brands: {
        create: "Marke schaffen",
        brand_saved: "Marke gespeichert",
        change_brand: "Marke ändern",
        edit: {
            authorized_person: "autorisierte Personen"
        },
        posted_by_ambassador_text: 'Diese Marke wurde von einem Latinmap -Botschafter erstellt, einem vertrauenswürdigen Community -Mitglied, das zu Plattforminhalten beiträgt.',
    },
    contact: {
        title: "Kontakt",
        name: "Name",
        email: "E-Mail",
        message: "Nachricht",
        subject: "Thema",
        send: "schicken",
        success: "Nachricht gesendet",
        error: "Nachricht konnte nicht gesendet werden",
    },
    ticketstore: {
        select_amount: 'Wählen Sie Ticketbetrag',
        your_information: 'Ihre Informationen',
        total: 'gesamt',
        next: 'nächste',
        back: 'zurück',
        checkout: 'Kasse',
        tickets_for: 'Tickets für',
        ticket_types: 'Ticketypen',
        ticket: {
            starts_at: 'beginnt bei',
            location: 'Standort',
            name: 'Name',
            description: 'Beschreibung',
            tickets_sold: 'Tickets verkauft',
            actions: 'Aktionen',
            available: 'verfügbar',
            total_available: 'Gesamt verfügbar',
            price: 'Preis',
            create: 'Tickettyp erstellen',
            edit: 'Tickettyp bearbeiten',
            success: 'Ihr Ticketyp wurde erfolgreich eingereicht.',
            remove_label: 'Tickettyp entfernen',
            remove_description: 'Dadurch wird der Tickettyp und alle zugehörigen Daten entfernt.',
        },
    },
    events: {
        owned_by_organization: 'Im Besitz der Organisation {organization_name}',
        select_category: "Wählen Sie eine Kategorie aus",
        select_country: "Wählen Sie ein Land",
        select_timezone: "Wählen Sie eine Zeitzone aus",
        select_status: "Wählen Sie einen Status aus",
        select_currency: "Wählen Sie eine Währung",
        select_brand_error: "Keine Marke ausgewählt",
        title: 'Ereignisse',
        bring_online: 'online bringen',
        take_offline: 'offline nehmen',
        by: 'Ereignisse von {organization_name}',
        create_new: 'Neue Veranstaltung erstellen',
        event_saved: 'Ereignis gespeichert',
        event_published: 'Ihre Veranstaltung ist jetzt live und sichtbar auf der Veranstaltungsseite.',
        error_saving: 'Fehler speichern Ereignis',
        containing_emoji_error: 'Emojis sind im Namen nicht zulässig. Verwenden Sie alphanumerische Zeichen oder zulässige Sonderzeichen.',
        invalid_character_error: 'Der Name enthält ein ungültiges Zeichen. Verwenden Sie alphanumerische Zeichen oder zulässige Sonderzeichen.\nUngültige Zeichen: ',
        duration_too_long: 'Die Dauer dieser Veranstaltung ist zu lang, die maximale Anzahl von Tagen, die eine Veranstaltung dauern darf, beträgt: ',
        error_updating_ticket_type: 'Ein Fehler beim Speichern des Ticketyps.',
        ticket_type_updated: 'Der Ticketyp wurde erfolgreich aktualisiert.',
        posted_by_ambassador: 'Gepostet von latinmap Botschafter',
        posted_by_ambassador_text: 'Diese Veranstaltung wurde von einem Latinmap -Botschafter erstellt, einem vertrauenswürdigen Community -Mitglied, das zu Plattforminhalten beiträgt.',
        posted_on_behalf_text: 'LatinMap hat diese Veranstaltung auf Grundlage öffentlich verfügbarer Informationen hinzugefügt. Der Veranstalter hat diese Informationen noch nicht selbst aktualisiert.',
        posted_on_behalf_label: 'von LatinMap hinzugefügt',
        // LA-202: the public pill on the event page. Separate from the
        // line above, which is appended to a title in the organiser's own
        // list and reads as a note rather than a credit.
        posted_by_latinmap: 'Von LatinMap eingestellt',
        not_posted_by_ambassador: 'vom Organisator verifiziert',
        participants: {
            create: {
                title: 'Create participant for "{event_name}"',
                description: 'Create a new participant for the event "{event_name}"',
                invite: 'Teilnehmer einladen',
                role: 'Rolle',
            },
            role: {
                performer: 'Künstlerin',
                organizer: 'Veranstalterin',
            },
            overview: {
                participants: 'Teilnehmer',
            }
        },
        statuses: {
            active: 'aktiv',
            canceled: 'abgesagt',
            changed: 'verändert',
            pending: 'ausstehend'
        },
        currencies: {
            none: 'keine Währung',
            euro: 'Euro',
            dollar_american: 'Amerikanischer Dollar',
            pound_uk: 'Englisches Pfund',
            lira_turkish: 'Türkische Lira',
            rupee_indian: 'Indische Rupie'
        },
        event_detail: {
            cta_block: {
                title: 'Tickets',
                subtitle: 'Für diese Veranstaltung sind Tickets verfügbar!',
                button: 'Holen Sie sich jetzt Ihre Tickets'
            },
            organizer: {
                plural: 'Organisatorinnen',
                singular: 'Veranstalterin',
                invariable: 'Organisatorinnen)',
            }
        },
        overview: {
            title: 'Ereignisse',
            nearby_events: 'Events in der Nähe',
            subtitle: 'Tauchen Sie in die rhythmischen Beats, berauschende Bewegungen und kulturelle Fusion von Salsa, Bachata und mehr ein.',
            festival: {
                title: 'Tanzfestivals und Kongresse',
            },
            try_out: {
                title: 'Try-outs, Tag der offenen Tür, Kursbeginn',
            },
            party_social: {
                title: 'Partys und Socials',
            },
            no_results: {
                title: 'Keine Ereignisse gefunden',
                subtitle: 'Keine Ereignisse für die ausgewählten Filter gefunden.'
            },
            filters: {
                event_name: 'Event- oder Organisationsname',
                event_id: 'Event-ID',
                event_category: 'Ereignisart',
                dance_styles: 'Tanzstile',
                dance_style: 'Tanzstil',
                music_styles: 'Musikstile',
                music_style: 'Musikstil',
                ambassadors: 'Botschafter',
                status: 'Status',
                user_name: 'Benutzerin',
                user_type: 'Benutzerart',
                organization: 'Organisation',
                organization_type: 'Organisationstyp',
                location: 'Wo',
                date: 'Wann',
                date_from: 'aus',
                date_to: 'Zu',
                apply_filters: 'Filter anwenden',
                clear_filters: 'klare Filter',
                country_codes: 'Ländercodes',
                city: 'Stadt',
                favorites: 'Favoritinnen',
                postal_code: 'Postleitzahl',
                nearby_range: 'In der Nähe der Postleitzahl Vorschläge Bereiche Range',
                apply: 'anwenden',
                sliderinfo: 'Inkremente von 100',
                slidertooltip: '<p><strong Der Bereich Slider passt die Ziffern der eingegebenen Postleitzahl an, um den Suchbereich zu erweitern.',
                option_labels: {
                    date_filter: {
                        upcoming: 'bevorstehend',
                        this_week: 'diese Woche',
                        next_week: 'Nächste Woche',
                        in_two_weeks: 'In zwei Wochen +',
                        this_month: 'diesen Monat',
                        specific_dates: 'Spezifische Daten',
                        all: 'alle'
                    },
                    favorites: {
                        all: 'alle',
                        favorites: 'Favoritinnen',
                        likes: 'Zeigen Sie nur meine gemochten Ereignisse',
                        favorites_likes: 'Show gemochte Events oder Events von Favoritenmarken',
                    },
                    organization_type: {
                        all: 'alle',
                        dance_schools: 'Tanzschulen',
                        organizers: 'Organisatorinnen',
                        music_styles: 'Musikstile',
                        music_style: 'Musikstil',
                        artists: 'Lehrer und Künstler',
                        disk_jockeys: 'DJs',
                    },
                    user_type: {
                        professional: 'Professional',
                        ambassador: 'Botschafterin',
                        admin: 'Administratorin',
                        superadmin: 'Superadmin'
                    }
                }
            },
            workshop_bootcamp: {
                title: 'Workshops und Bootcamps',
            },
        },
        type: {
            festivals_and_congresses: 'Festivals und Kongresse',
            try_out: 'Try-outs, Tag der offenen Tür, Kursbeginn',
            live_music: 'Live -Bands/Musik',
            workshop_bootcamp: 'Workshops und Bootcamps',
        },
        categories: {
            festival: 'Festival/Kongress',
            workshop_bootcamp: 'Workshop/Bootcamp',
            workshop_bootcamp_party: 'Party mit Workshop/Bootcamp',
            party_social: 'Partei/Sozial',
            competition: 'Wettbewerb',
            performance_concert: 'Performance/Konzert',
            outdoor_event: 'Outdoor -Veranstaltung',
            dance_trip: 'Tanzreise',
            party_live_music: 'Party/Live -Musik',
            online_event: 'Online -Veranstaltung',
            try_out: 'Try-outs, Tag der offenen Tür, Kursbeginn',
            show: 'zeigen',
            marathon: 'Marathon',
            weekender: 'Weekender',
            retreat: 'Retreat',
            other: 'andere',
        },
        create: 'Ereignis erstellen',
        edit: 'Ereignis bearbeiten',
        remove: {
            label: 'Ereignis entfernen',
            description: 'Dadurch wird das Ereignis und alle zugehörigen Daten entfernt.',
        },
        brand: 'Marke/Organisation',
        name: 'Name',
        country: 'Land',
        city: 'Stadt',
        street: 'Straße',
        street_number: 'Straßennummer',
        short_description: 'Kurzbeschreibung',
        long_description: 'lange Beschreibung',
        dance_styles: 'Tanzstile',
        music_styles: 'Musikstile',
        photos: 'Fotos',
        photos_preview_mode: 'Fotos sind nach dem Speichern im Vorschautmodus sichtbar',
        preview: 'zeigen',
        category: 'Ereignisart',
        language: 'Sprache',
        location_type: {
            singular: 'Standorttyp',
            online: 'virtuell',
            offline: 'persönlich',
        },
        timezone: 'Zeitzone',
        date: 'Datum',
        week: 'Woche',
        start: 'Start',
        end: 'Ende',
        location: 'Standort',
        information: 'Information',
        start_date: 'Startdatum',
        start_time: 'Startzeit',
        end_date: 'Enddatum',
        end_time: 'Endzeit',
        ends_at: 'endet bei',
        registration_opens_at: 'Registrierung beginnt bei',
        registration_closes_at: 'Registrierung endet bei',
        is_public: 'Bereit, live zu gehen?',
        location_name: 'Veranstaltungsort Name',
        photos_required: 'Mindestens ein Foto ist erforderlich.',
        tickets_sold: 'Tickets verkauft',
        actions: 'Aktionen',
        participate: 'teilnehmen',
        verified: 'Markenbeamter verifiziert',
        undercondition: 'Noch nicht bestätigt',
        warning: 'Wichtige Änderung - Letztes Update:',
        ticket:'Tickets verfügbar',
        cancelled: 'Storniert - Letztes Update:',
        upcoming: 'bevorstehende Veranstaltungen',
        past: 'frühere Ereignisse',
        status: 'Status',
        status_reason: 'Statusgrund',
        entrance: 'Ticketpreise',
        entrance_tooltip: 'Hier können Sie den Ticketpreis angeben. Geben Sie eine Zahl ein, wenn sich der Preis nicht ändert, z. B. \'5\'. Für eine Preisspanne können Sie einen Bereich angeben, z. B. \'5-10\'. Verwenden Sie \'free\', wenn kein Eintrittspreis angegeben ist.',
        currency: 'Währung',
        currency_tooltip: 'Sie können auch die Währung angeben. Häufig verwendete Währungen sind: Euro (€), US-Dollar ($), Pfund Sterling (£), Türkische Lira (₺) und Indische Rupie (₹). Wenn keine Währung ausgewählt ist, können Sie einen beliebigen Text hinzufügen, z. B. \'5-12 Euro\'.',
        repeat: 'Wiederholungen',
        djs: 'DJs',
        dj: 'DJ',
        artists: 'Künstler',
        artist: 'Künstlerin',
        question: "Ihre Veranstaltung?",
        status_options: {
            active: 'aktiv',
            canceled: 'abgesagt',
            pending: 'Noch nicht bestätigt',
            changed: 'Wichtige Veränderung',
        },
        is_public_options: {
            draft: 'Entwurf',
            private: 'Privat',
            public: 'öffentlich',
            draft_message: 'Speichern Sie Ihr Ereignis als Entwurf.',
            private_message: 'Ihre Veranstaltung ist nur für Benutzer mit Zugriff sichtbar.',
            public_message: 'Veröffentlichen Sie Ihre Veranstaltung, um sie auf der Veranstaltungsseite sichtbar zu machen.',
            private_warning: 'Ihre Veranstaltung ist mit diesem Status online nicht sichtbar.'
        },
        legend: {
            title: 'Legende',
            verified: 'Markenbeamter verifiziert',
            not_verified: 'Nicht durch Organisation verifiziert: Der Organisator hat die Aktivität noch nicht bestätigt.',
            cancelled: 'abgesagt',
            warning: 'Wichtige Veränderung',
            posted_by: 'Gepostet von latinmap Botschafter',
            condition: 'Noch nicht bestätigt',
            ticket:'Tickets verfügbar',
            duplicate_event_error: 'Ein Ereignis mit diesem Namen, dem Startdatum und dem Enddatum gibt es bereits',
            ticket_order: 'Tickets verfügbar, bestellen Sie sie hier!'
        },
        ticket_types: 'Ticketypen',
        potential_duplicates: 'mögliche Duplikate',
        proceed_anyway: 'sparen trotz doppelter',
        duplicate_event_error: 'Ein Ereignis mit diesem Namen, dem Startdatum und dem Enddatum gibt es bereits',
        event_deleted: 'Ereignis gelöscht',
        error_deleting_event: 'Fehler beim Löschen von Ereignissen',
        featured: {
            title: 'Ausgewählte Veranstaltungen in der Community',
            subtitle: 'Entdecken Sie und bringen Sie Ihre Tickets für Tanzfestivals, Konzerte und Ausflüge zum besten Preis!',
            badge: 'Hervorgehoben',
            view: 'Event ansehen',
            title_page: 'weltweit ändern',
            featured_event: "Kaufen Sie vorgestellte Veranstaltung",
            duration_type: "Dauertyp",
            day: "Tag",
            month: "Monat",
            year: "Jahr",
            duration: "Dauer",
            price: "Preis",
            calculate_price: "Preis berechnen",
            proceed_to_payment: "Fahren Sie mit der Zahlung fort",
            current_price: "Aktueller Preis",
            no_price_found: "Kein Preis für die ausgewählte Dauer gefunden",
            update_price: "Preis aktualisieren",
            setFeaturedEvents: "SET -Ereignis",
            fetch_current_price: "Aktuellen Preis holen",
            update_global_event_price: "Aktualisieren Sie den globalen Ereignispreis",
            price_per_day: 'Preis pro Tag',
            buy: 'Kaufen Sie vorgestellte Veranstaltung',
            duration_label: 'Wie lange möchten Sie die Veranstaltung vorstellen?',
            enter_duration: 'Wählen Sie Dauer',
            total_price: 'gesamt',
            yes: "Ja",
            no: "NEIN",
            invalid_invoice: 'Etwas lief schief, versuche es erneut',
            download_failed: 'Etwas lief schief, versuche es erneut',
            setFeaturedEvent: 'Set vorgestellte Veranstaltung für:',
            setFeatured: 'SET -Ereignis',
            featured_success: 'Die Veranstaltung wurde erfolgreich vorgestellt.',
            already_featured: 'Diese Veranstaltung ist bereits vorgestellt',
            featured_error: 'Etwas lief schief',
            durationError: 'Wert kann nicht weniger als 1 betragen'
        },
    },
    blocked_user:{
        create: 'Create blocked user',
        edit: 'Aktualisieren Sie den blockierten Benutzer',

        blocked_email: 'Blockierte E -Mail',
        blocked_phone_number: 'Blocked phone number',
        reason: 'Grund',

        delete: {
            warning: {
                title: 'Benutzerblockieren löschen',
                body: 'Sind Sie sicher, dass Sie diesen Block löschen möchten?'
            }
        }
    },
    carousel: {
        title: 'Entdecken Sie lateinamerikanischen Tanz - Veranstaltungen, Schulen, Proben und mehr in Ihrer Nähe!',
        subtitle: 'Finden Sie heraus, wo Sie tanzen, lernen und Kontakte zur lateinamerikanischen Community knüpfen können.',
        search: {
            placeholder: 'Geben Sie ein Schlüsselwort oder eine Stadt ein, um die Möglichkeiten des lateinamerikanischen Tanzes zu erkunden...',
            button: 'ENTDECKEN',
        }
    },
    home: {
        // LA-179: the official Instagram strip that closes the homepage.
        instagram: {
            title: 'Live von der Tanzfläche',
            subtitle: 'Das Neueste von unserem Instagram — die Szene, wie sie wirklich aussieht, Woche für Woche.',
            follow: '{handle} folgen',
            post_alt: 'Ein Beitrag von {handle} auf Instagram',
        },
        cta_block_1: {
            title: 'Organisieren Sie Tanzveranstaltungen?',
            subtitle:
                'Wenn Sie Partys, Festivals, Ausflüge, Kongresse, Wochenenden, Workshops, Intensivkurse und Tanzkonzerte organisieren, haben wir etwas für Sie. Bewerben Sie Ihre Veranstaltung, verwalten Sie Promoter und verkaufen Sie Tickets!',
            button: 'Jetzt anmelden'
        },
        cta_block_2: {
            title: 'Entdecken Sie Veranstaltungen in Ihrer Nähe',
            subtitle:
                'Entdecken Sie Veranstaltungen und Aktivitäten in Ihrer Umgebung. Erkunden und genießen Sie die Erlebnisse!',
            placeholder: 'Ihr Standort',
            input_button: 'In meiner Nähe',
            button: 'Veranstaltungen finden'
        },
        cta_block_3: {
            button: 'Veranstaltung erstellen',
        },
        choose_and_live_experiences: 'Wählen und erleben Sie Erfahrungen',
        experiences: {
            festivals_congresses: "Festivals & Kongresse",
            parties_socials: "Partys, Socials",
            try_outs_start_courses: "Probestunden, Anfängerkurse",
            dance_schools: "Tanzschulen",
            workshops_bootcamps: "Workshops, Bootcamps",
            dancewear_shoes: "Tanzbekleidung & Schuhe",
            teachers: "Lehrer",
            show_performers_teams: "Showkünstler & Teams",
            djs: 'DJ\'s',
            live_music: "Live-Bands",
            media_photo_video: "Medien (Foto/Video)",
            mcs: "MC's"
        },
        cta_journey: {
            title: 'Starte deine LatinMap Reise',
            subtitle: 'Wähle, wie du LatinMap erleben möchtest',
            agenda: {
                title: 'Weltweite Agenda',
                sub_header: 'Kostenlos durchsuchen',
                subtitle: 'Entdecke die globale Latin Dance Szene',
                description: 'Durchsuche Partys, Workshops, Festivals, Schnupperkurse & Anfängerkurse - alles in einer Agenda',
                button: 'Latin Agenda ansehen',
                footer: 'Kein Konto erforderlich'
            },
            member: {
                title: 'Werde Mitglied',
                sub_header: 'Kostenloses Konto',
                subtitle: 'Gestalte dein eigenes LatinMap Erlebnis',
                description: 'Erstelle deine persönliche LatinMap und bleibe mit der Latin Dance Szene verbunden — lokal und international.',
                features: {
                    agenda: 'Vollständige & aktuelle Latin Dance Agenda',
                    follow: 'Folge deinen Lieblings-Events, Künstlern & Marken',
                    save: 'Speichere deine Favoriten mit einem Klick',
                    store: 'Speichere deine Suchen & Entdeckungen',
                    custom_agenda: 'Erstelle deine eigene Agenda',
                    explore: 'Entdecke neue Städte, Stile & Szenen'
                },
                button: 'Kostenloses Konto erstellen',
                footer: 'Kostenlos beitreten – verpasse nie wieder ein Event'
            },
            professional: {
                title: 'Werde Professional',
                sub_header: 'Kostenloses professionelles Profil',
                subtitle: 'Für Festivals, Tanzschulen, Lehrer, DJs, Musiker & Veranstalter',
                description: 'Steigere deine Sichtbarkeit, verwalte deine Events und erreiche die internationale Latin Community.',
                features: {
                    brand_page: 'Deine eigene professionelle Markenseite',
                    publish: 'Veröffentliche & verwalte Events einfach',
                    invite: 'Lade Teammitglieder zur Zusammenarbeit ein',
                    insights: 'Einblicke, Statistiken & Wachstumstools',
                    exposure: 'Internationale Präsenz auf LatinMap'
                },
                button: 'Pro-Konto aktivieren',
                footer: 'Erfordert zuerst ein Mitgliedskonto'
            }
        },
    },
    dropzone: {
        drop_here: 'Lassen Sie Dateien hier zum Hochladen fallen',
        files_required: "{count} Erforderlich",
        max_filesize: "Maximale Dateigröße: {max} mb"
    },
    general: {
        select_organization_please: "Bitte wählen Sie eine Organisation aus",
        no_organization_selected: "Keine Organisation ausgewählt",
        all: 'alle',
        styles: 'Stile',
        important_information: 'Wichtige Informationen',
        starts_at: 'aus',
        ends_at: 'Zu',
        socialmedia_links: 'Links',
        share_with_your_friends: 'Mit deinen Freunden teilen',
        link_copied: 'Link in Zwischenablage kopiert!',
        link_copy_failed: 'Link konnte nicht kopiert werden.',
        hosted_by: 'moderiert von',
        created_by: 'erstellt von',
        posted_by: 'Veröffentlicht von',
        created: 'erstellt',
        archive: 'Archiv',
        modified: 'verändert',
        score: 'Punktzahl',
        reset: 'zurücksetzen',
        unknown: 'unbekannt',
        submit: 'einreichen',
        suggest: 'vorschlagen',
        other: 'andere',
        delete: 'löschen',
        copy_link: 'Link kopieren',
        back: 'zurück',
        show: 'zeigen',
        duplicate: 'Duplikat',
        proceed: 'fortfahren',
        cancel: 'stornieren',
        accept: 'akzeptieren',
        reject: 'Ablehnen',
        show_in_new_window: 'im neuen Fenster zeigen',
        checkout: 'Kasse',
        external_link_warning: {
            title: 'Externer Link',
            content: 'Sie sind dabei, diese Seite zu verlassen.',
            question: 'Möchten Sie zur folgenden URL fortfahren?',
        },
        add: 'hinzufügen',
        date: 'Datum',
        search: {
            save_new: 'Neue Suche speichern',
            instructions: 'Speichern Sie Ihre Suche, um sie später erneut zu verwenden.',
            name: 'Name',
            none_stored: 'Sie haben noch keine gespeicherten Suchanfragen.',
            stored: 'Speicherne Suchanfragen',
            events: 'Ereignisse',
            organizations: 'Organisationen',
            paginate: 'pro Seite',
            page: 'Seite',
            view: 'Sicht',
            filters: 'Filter',
            delete: 'löschen',
            views: {
                grid: 'Netz',
                list: 'Liste',
                agenda: 'Agenda',
                monthlist: 'Monatsliste',
            },
            filter_labels: {
                name: 'Name',
                location: 'Standort',
                dance_styles: 'Tanzstile',
                music_styles: 'Musikstile',
                event_categories: 'Ereigniskategorien',
                date_filter: 'Datum',
                favorites: 'Favoritinnen',
                country_codes: 'Ländercodes',
                organization_type: 'Organisationstypen',
            },
        },
        socials: {
            facebook: 'Facebook',
            instagram: 'Instagram',
            site: 'Webseite',
            linkedin: 'LinkedIn',
            youtube: 'YouTube',
            tiktok: 'Tiktok',
            reddit: 'Reddit',
            pinterest: 'Pinterest',
            twitter: 'X',
            spotify: 'Spotify',
            soundcloud: 'SoundCloud',
            facebook_event: 'Facebook-Veranstaltung',
            whatsapp: 'WhatsApp',
        },
        description: {
            title: 'Beschreibung',
            show_more: 'Zeigen Sie mehr',
            show_less: 'weniger zeigen',
        },
        map: 'Karte',
        gmap_block: {
            title: 'Karte',
            location_name: 'Standortname'
        },
        spotify_block: {
            title: 'Spotify',
        },
        soundcloud_block: {
            title: 'SoundCloud',
        },
        paginate: {
            results: 'Ergebnisse',
            filter: 'Filter',
            open_filter: 'offener Filter',
        },
        edit: 'bearbeiten',
        create: 'erstellen',
        expand: 'mehr',
        more_info: 'Weitere Informationen',
        collapse: 'weniger',
        unique_impressions: 'einzigartige Eindrücke',
        close: 'schließen',
        save_changes: 'Änderungen speichern',
        update_changes: 'Änderungen speichern',
        scrollright: 'Scrollen Sie nach rechts für weitere Details.'
    },
    header: {
        title: 'LatinMap',
        navigation: 'Navigation',
        cta: 'Ereignis erstellen',
    },
    date: {
        from: 'aus',
        to: 'Zu',
    },
    report: {
        event: 'Berichtsereignis',
        organization: 'Berichtsorganisation',
        name: 'Name',
        location: 'Standort',
        date: 'Datum',
        success: 'Ihr Bericht wurde erfolgreich eingereicht.',
        not_logged_in: 'Konto erforderlich',
        tooltip: 'Bericht',
        status: {
            warning: {
                title: 'Berichtsstatus aktualisieren',
                body: 'Möchten Sie den Berichtsstatus dieses Berichts wirklich ändern?'
            }
        },
        archive: {
            warning: {
                title: 'Archivbericht',
                body: 'Möchten Sie diesen Bericht wirklich archivieren? Dies kann nicht rückgängig gemacht werden.'
            }
        }
    },
    form: {
        save: 'speichern',
        save_and_verify: 'Speichern und überprüfen',
        too_many_requests: 'Sie haben das Nachrichtenlimit erreicht. ' +
            'Bitte warten Sie einige Minuten, bevor Sie eine weitere Anfrage senden.',
    },
    form_subject: {
        general_inquiry: "Allgemeine Anfrage",
        technical_support: "technische Unterstützung",
        issue_event_submission: "Ereignisübermittlungsproblem",
        issue_account_login: "Konto oder Anmeldeproblem",
        question_billing_payment: "Abrechnung oder Zahlungsfrage",
        report_issue: "ein Problem melden",
        suggest_feature: "Feature -Vorschlag",
        other: "andere"
    },
    api: {
        general: {
            validation_error: 'Validierungsfehler',
            permission_denied: 'Zugriff verweigert',
            success: 'Erfolg',
        },
        auth: {
            unauthorized: 'Sie sind nicht berechtigt, auf diese Ressource zuzugreifen.',
            blocked: 'Ihr Konto wurde blockiert, Sie können keine Funktionen zugreifen.',
            user_not_found: 'Ein Konto ist erforderlich, um diese Funktionalität zu verwenden. Bitte erstellen Sie zuerst ein Konto.',
            email_password_unknown: 'Die bereitgestellte E -Mail -Adresse oder Passwort ist falsch.',
            email_unverified: 'Ihre E -Mail -Adresse wird nicht überprüft.',
            email_already_verified: 'Ihre E -Mail -Adresse ist bereits überprüft.',
            phone_already_verified: 'your phonenumber is already verified.',
            phone_already_used: 'Diese Telefonnummer ist bereits verwendet',
            invalid_verification_link: 'Die bereitgestellte Überprüfungsverbindung ist ungültig.',
            email_verified_success: 'Ihre E -Mail -Adresse wurde überprüft.',
            verification_email_sent: 'Ein Überprüfungslink wurde an Ihre E -Mail -Adresse gesendet.',
            login_success: 'Sie haben sich erfolgreich angemeldet.',
            logout_success: 'Sie haben sich erfolgreich angemeldet.',
            registration_success: 'Sie haben sich erfolgreich registriert.',
            failed: 'Diese Anmeldeinformationen stimmen nicht mit unseren Datensätzen überein.',
            password: 'Das bereitgestellte Passwort ist falsch.',
            throttle: 'Zu viele Anmeldeversuche.',
            user_updated_success: 'Ihr Konto wurde erfolgreich aktualisiert.',
            old_password_incorrect: 'Das bereitgestellte alte Passwort ist falsch.',
            password_changed_success: 'Ihr Passwort wurde erfolgreich geändert.',
            user_deleted_success: 'Ihr Konto wurde erfolgreich gelöscht.',
            verification_text_sent: 'Ein Überprüfungstext wurde an Ihre Telefonnummer gesendet.',
            invite_invalid: 'Die gebrauchte Einladungs URL ist ungültig.',
            too_many_requests: 'Too many requests. Please try again later.',
            day_limit_exceeded: 'Sie haben heute die maximale Menge an Anfragen für diese Funktionalität überschritten.'
        },
        organization: {
            created_success: 'Die Organisation wurde erfolgreich erstellt.',
            authorized_person: {
                created: 'Die autorisierte Person wurde erfolgreich erstellt.',
                updated: 'Die autorisierte Person wurde erfolgreich aktualisiert.',
                removed: 'Die autorisierte Person wurde erfolgreich entfernt.',
                not_found: 'Die autorisierte Person konnte nicht gefunden werden.',
                already_exists: 'Die autorisierte Person existiert bereits.',
                role: {
                    singular: 'Rolle',
                    invalid: 'Die bereitgestellte Rolle ist ungültig.',
                    eventPublisher: 'Eventverlag',
                    eventCreator: 'Event -Schöpfer',
                    authorizedPerson: 'autorisierte Person',
                }
            },
        },
        event: {
            created_success: 'Die Veranstaltung wurde erfolgreich erstellt.',
            deleted_success: 'Die Veranstaltung wurde erfolgreich gelöscht.',
        },
        report: {
            created_success: 'Der Bericht wurde erfolgreich erstellt.',
            invalid_type: 'Der bereitgestellte Berichtstyp ist ungültig.',
        },
        user: {
            updated_success: 'Der Benutzer wurde erfolgreich aktualisiert.',
            search_filter: {
                created: 'erstellt',
            }
        },
        upload: {
            created_success: 'Der Upload wurde erfolgreich erstellt.',
            deleted_success: 'Der Upload wurde erfolgreich gelöscht.',
        },
        forms: {
            submitted_success: 'Das Formular wurde erfolgreich eingereicht.',
        },
        passwords: {
            reset: 'Ihr Passwort wurde zurückgesetzt.',
            sent: 'Wir haben Ihren Link zum Zurücksetzen des Passworts per E -Mail gesendet!',
            throttled: 'Bitte warten Sie, bevor Sie erneut versuchen.',
            token: 'Dieses Token für Passwort Reset ist ungültig.',
            user: 'Wir können einen Benutzer mit dieser E -Mail -Adresse nicht finden.',
        },
        pagination: {
            previous: '&laquo; vorherige',
            next: 'nächste &raquo;',
        },
        dance_style: {
            saved_success: 'Der Tanzstil wurde gerettet.',
            deleted_success: 'Der Tanzstil wurde erfolgreich gelöscht.',
            deleted_error: 'Fehler beim Löschen des Tanzstils',
            not_found: 'Der Tanzstil konnte nicht gefunden werden.',
            parent_not_found: 'Der Elterntanzstil konnte nicht gefunden werden.',
            suggest_success: 'Vorschläge im Tanzstil gesendet.',
        },
        music_style: {
            saved_success: 'Der Musikstil wurde gerettet.',
            deleted_success: 'Der Musikstil wurde erfolgreich gelöscht.',
            not_found: 'Der Musikstil konnte nicht gefunden werden.',
            parent_not_found: 'Der Elternmusikstil konnte nicht gefunden werden.',
            suggest_success: 'Vorschläge im Musikstil gesendet.',
        },
        invite: {
            sent: 'Einladung gesendet',
            removed: 'Einladung entfernt',
            resend_success: 'Einladungsrückgang'
        },
        transfer_request: {
            already_owner: 'Sie sind bereits Eigentümer dieser Organisation.',
            organization_already_owns_event: 'Die Organisation besitzt die Veranstaltung bereits.',
        },
        transferlink: {
            removed: 'Der TransferLink wurde entfernt.'
        },
        user_block: {
            create_success: 'Benutzerblock wurde erfolgreich erstellt.',
            update_success: 'User block was successfully updated.',
            delete_success: 'Der Benutzerblock wurde erfolgreich gelöscht.'
        },
    },
    favorites: {
        favorite: 'Favoritin',
        like: 'wie',
        login_required: 'Sie müssen angemeldet sein, um dies Ihren Favoriten hinzuzufügen.',
    },
    likes: {
        login_required: 'Sie müssen angemeldet sein, um dies Ihren Vorlieben hinzuzufügen.',
    },
    validations: {
        validations: {
            doesnt_exist: {
                'owner id': 'konnte den Benutzer nicht finden, um diese Organisation im Namen von zu erstellen.'
            }
        },
        on_behalf_of: {
            required: 'Das im Namen des Feldes ist erforderlich.',
        },
        required: 'Dieses Feld ist erforderlich.',
        phone: {
            required: 'Die Telefonnummer ist erforderlich.',
            regex: 'Die Telefonnummer ist ungültig.',
            length: 'Die Telefonnummer muss mindestens 10 Ziffern lang sein.',
        },
        'phone number': {
            required: 'Die Telefonnummer ist erforderlich.',
            regex: 'Die Telefonnummer ist ungültig.',
            'not-unique': 'Diese Telefonnummer wird bereits verwendet.',
        },
        number: {
            required: 'Die Nummer ist erforderlich.',
            invalid: 'Die Nummer ist ungültig.'
        },
        email: {
            required: 'Die E -Mail -Adresse ist erforderlich.',
            invalid: 'Die E -Mail -Adresse ist ungültig.',
            'not-unique': 'The email addres is not unique.'
        },
        name: {
            required: 'Der Name ist erforderlich.',
            max_length: 'Der Name ist zu lang.',
        },
        username: {
            required: 'Der Benutzername ist erforderlich.',
            invalid: 'Der Benutzername ist ungültig.',
        },
        first_name: {
            required: 'Der Vorname ist erforderlich.',
        },
        last_name: {
            required: 'Der Nachname ist erforderlich.',
        },
        gender: {
            required: 'Das Geschlecht ist erforderlich'
        },
        city: {
            required: 'Die Stadt ist erforderlich.',
        },
        street: {
            required: 'Die Straße ist erforderlich.',
        },
        street_number: {
            required: 'Die Straßennummer ist erforderlich.',
        },
        country: {
            required: 'Das Land ist erforderlich.',
        },
        brand: {
            required: 'Die Marke ist erforderlich.'
        },
        short_description: {
            required: 'Die kurze Beschreibung ist erforderlich.',
        },
        long_description: {
            required: 'Die lange Beschreibung ist erforderlich.',
        },
        description: {
            required: 'Die Beschreibung ist erforderlich.',
        },
        type: {
            required: 'Der Typ ist erforderlich.',
        },
        message: {
            required: 'Die Nachricht ist erforderlich.',
        },
        date_of_birth: {
            required: 'Das Geburtsdatum ist erforderlich.',
            regex: 'Das Geburtsdatum ist ungültig.',
            age: 'Sie müssen mindestens 18 Jahre alt sein.',
            old: 'Sie müssen höchstens 120 Jahre alt sein.'
        },
        date: {
            required: 'Das Datum ist erforderlich.',
            regex: 'Das Datum ist ungültig.',
        },
        postal_code: {
            required: 'Die Postleitzahl ist erforderlich.',
            length: 'Die Postleitzahl muss mindestens 4 Ziffern lang sein.',
        },
        entrance: {
            required: 'Die Ticketpreise sind erforderlich.',
        },
        repeat: {
            required: 'Die Wiederholung ist erforderlich.',
        },
        password: {
            required: 'Das Passwort ist erforderlich.',
            regex: 'Gültiges Passwort erforderlich.',
            confirmed: 'Die Passwortbestätigung stimmt nicht überein.',
            mismatch: 'Das Passwort stimmt nicht überein.',
        },
        conditions: {
            required: 'Sie müssen die Allgemeinen Geschäftsbedingungen akzeptieren.',
        },
        url: {
            required: 'Die URL ist erforderlich.',
            regex: 'Die URL ist ungültig.',
        },
        event_category: {
            required: 'Der Ereignisart ist erforderlich.',
        },
        language_code: {
            required: 'Die Sprache ist erforderlich.',
        },
        timezone: {
            required: 'Die Zeitzone ist erforderlich.',
        },
        is_public: {
            required: 'Die Sichtbarkeit ist erforderlich.',
        },
        form_subject: {
            required: 'Das Thema ist erforderlich.',
        },
        starts_at: {
            required: 'Das Startdatum ist erforderlich.',
            regex: 'Das Startdatum ist ungültig.',
        },
        start_date: {
            required: 'Das Startdatum ist erforderlich.',
            regex: 'Das Startdatum ist ungültig.',
            after_end_date: "Das Startdatum muss vor dem Enddatum sein.",
        },
        start_time: {
            required: 'Die Startzeit ist erforderlich.',
            regex: 'Die Startzeit ist ungültig.',
        },
        end_date: {
            required: 'Das Enddatum ist erforderlich.',
            regex: 'Das Enddatum ist ungültig.',
            before_start_date: "Das Enddatum muss nach dem Startdatum erfolgen.",
        },
        end_time: {
            required: 'Die Endzeit ist erforderlich.',
            regex: 'Die Endzeit ist ungültig.',
        },
        ends_at: {
            required: 'Das Enddatum ist erforderlich.',
            regex: 'Das Enddatum ist ungültig.',
            before_start_date: "Das Enddatum muss nach dem Startdatum erfolgen.",
        },
        registration_opens_at: {
            required: 'Das Startdatum der Registrierung ist erforderlich.',
            regex: 'Das Registrierungsstartdatum ist ungültig.',
        },
        registration_closes_at: {
            required: 'Das Registrierungsenddatum ist erforderlich.',
            regex: 'Das Registrierungsenddatum ist ungültig.',
        },
        location_type: {
            required: 'Der Standorttyp ist erforderlich.',
        },
        location_name: {
            required: 'Der Standortname ist erforderlich.',
        },
        dance_styles: {
            required: 'Die Tanzstile sind erforderlich.',
        },
        music_styles: {
            required: 'Die Musikstile sind erforderlich.',
        },
        photos: {
            required: 'Mindestens 1 Foto ist erforderlich.',
        },
        status: {
            required: 'Der Status ist erforderlich.',
        },
        string: {
            required: '{fieldname} ist erforderlich.',
            mismatch: '"{input}" passt nicht "{safeword}".',
        },
        role: {
            required: 'Die Rolle ist erforderlich.',
        },
        favorite: {
            required: 'Favorit ist erforderlich.',
        },
        dance_style: {
            required: 'Tanzstil ist erforderlich.',
        },
        facebook: {
            required: 'Der Facebook -Link ist erforderlich.',
            regex: 'Bitte geben Sie einen gültigen Facebook -Link ein.',
        },
        facebook_event: {
            required: 'Der Link zur Facebook-Veranstaltung ist erforderlich.',
            regex: 'Geben Sie eine Facebook-Event-URL ein — sie muss auf facebook.com/events/{id} verweisen.',
        },
        instagram: {
            required: 'Der Instagram -Link ist erforderlich.',
            regex: 'Bitte geben Sie einen gültigen Instagram -Link ein.',
        },
        website: {
            required: 'Der Website -Link ist erforderlich.',
            regex: 'Bitte geben Sie einen gültigen Website -Link ein.',
        },
        twitter: {
            required: 'Der X -Link ist erforderlich.',
            regex: 'Bitte geben Sie einen gültigen X -Link ein.',
        },
        linkedin: {
            required: 'Der LinkedIn -Link ist erforderlich.',
            regex: 'Bitte geben Sie einen gültigen LinkedIn -Link ein.',
        },
        youtube: {
            required: 'Der YouTube -Link ist erforderlich.',
            regex: 'Bitte geben Sie einen gültigen YouTube -Link ein.',
        },
        spotify: {
            required: 'Der Spotify -Link ist erforderlich.',
            invalid: 'Bitte geben Sie einen gültigen Spotify -Link im richtigen Format ein.',
            regex: 'Bitte geben Sie einen gültigen Spotify -Link im richtigen Format ein.',
        },
        soundcloud: {
            required: 'Der SoundCloud-Link ist erforderlich.',
            invalid: 'Bitte geben Sie einen gültigen SoundCloud-Link im richtigen Format ein.',
            regex: 'Bitte geben Sie einen gültigen SoundCloud-Link im richtigen Format ein.',
        },
        twitter: {
            required: 'Der Twitter -Link ist erforderlich.',
            regex: 'Bitte geben Sie einen gültigen Twitter -Link ein.',
        },
        doesnt_exist: {
            email: 'Die bereitgestellte E -Mail -Adresse ist nicht vorhanden.',
            user: 'Der bereitgestellte Benutzer existiert nicht.',
        },
        djs: {
            required: 'Die DJs sind erforderlich.',
        },
        artists: {
            required: 'Die Künstler sind erforderlich.',
        },
        reason: {
            required: 'The reason is required.'
        },
        default: {
            doesnt_exist: {
                email: 'Die bereitgestellte E -Mail -Adresse ist nicht vorhanden.',
                user: 'Der bereitgestellte Benutzer existiert nicht.',
            }
        }
    },
    brand_activity: {
        by_brand: 'Marken-Nutzer',
        by_admin: 'Admin/Scraping',
        export: 'CSV exportieren',
    },
    paginatable: {
        headers: {
            last_event_at: 'Letzte Event-Aktivität',
            last_event_by: 'Letztes Event von',
            has_upcoming: 'Bevorstehend veröffentlicht',
            id: 'Ausweis',
            brand_id: 'Marken ID',
            title: 'Titel',
            slug: 'Slug',
            group: 'Gruppe',
            email: 'E-mail',
            phone: 'Telefonnummer',
            name: 'Name',
            first_name: 'Vorname',
            last_name: 'Nachname',
            role_name: 'Rolle',
            role: 'Rolle',
            report: 'Bericht',
            created_at_formatted: 'erstellt at',
            status: 'Status',
            actions: 'Aktionen',
            type: 'Typ',
            to_user_email: 'Zu e-mail',
            from_user_email: 'Aus e-mail',
            reason: 'Grund',
            organization_name: 'Organisationsname',
            organization_created: 'Organisation erstellt',
            organization_updated: 'Organisation zuletzt aktualisiert',
            confirmed_at: 'bestätigt bei',
            organization_role: 'Rolle',
            sub_dance_styles: 'Untertanzstile',
            sub_music_styles: 'Submusikstile',
            city: 'Stadt',
            created_at: 'erstellt',
            updated_at: 'verändert',
            is_favorite: 'Favoritin',
            starts_at: 'beginnt bei',
            tickets_sold: 'Tickets verkauft',
            price: 'Preis',
            start_date: 'Startdatum',
            is_public: 'öffentlich',
            available_tickets: 'Verfügbare Tickets',
            user_id: 'Benutzer-ID',
            transferable_type: 'Typ',
            content_name: 'Titel',
            paynl_transaction_id: 'Paynl Transaktion',
            date: 'Kaufdatum',
            amount: 'Gesamtbetrag',
            tax_amount: 'Steuer',
            currency: 'Währung',
            description: 'Beschreibung',
            valid_from: 'Start',
            valid_until: 'Ablauf',
            items: 'Artikel',
            total: 'gesamt',
            featured: 'vorgestellt',
            created_by: 'Benutzerin',
            location_type: 'Standorttyp',
            category_id: 'Kategorie',
            organization_category_id: 'Kategorie',
            country_code: 'Landesvorwahl',
            location: 'Standort',
            info: 'Benutzerinformationen',
            owner: 'Repräsentation',
            adres: 'Adresse',
            export_created: "Export erstellt",
            image_path: "Bildpfad",
            image_alt: "Bildbeschreibung",
            image_title: "Bildtitel",
            image: "Bild",
            order_by: "Sortieren nach",
            visibility: "Sichtbarkeit",
            public_status: "Öffentlicher Status",
            country: 'Land',
            activity: 'Aktivität',
        },
        search: 'suchen',
        no_records: 'Keine Ergebnisse gefunden',
    },
    pages: {
        related: 'Verwandte Seiten',
        contact: {
            title: 'Wenden Sie sich an LatinMap',
            body: 'Bei Fragen zu Veranstaltungen wenden Sie sich bitte an die Organisation, die die Veranstaltung veröffentlicht hat.'
        },
        'how-it-works': {
            title: 'Wie es funktioniert',
            body: '<p> Online -Ticketverkäufe über latinmap.com </p><p> Wir bieten Organisationen die Möglichkeit eines Online -Ticketverkaufs.'
        },
        'goods-and-services': {
            title: 'Waren und Dienstleistungen',
            body: '<p> latinmap.com: Entdecken und erleben Sie die lateinische Tanzwelt </p><p> Willkommen bei latinmap.com, dem Ziel, wo Sie mühelos Zugang zu den aufregendsten Ereignissen und Erfahrungen in der Welt des lateinischen Tanzes erhalten.'
        },
        'terms-and-conditions': {
            title: 'Geschäftsbedingungen',
            body: '<p>20230529 Allgemeine Geschäftsbedingungen für den Ticketverkauf</p><p>1. Definitionen</p><p>Die hier mit einem Großbuchstaben beginnend definierten Begriffe haben in diesen Allgemeinen Geschäftsbedingungen folgende Bedeutung:<br/>a. Allgemeine Geschäftsbedingungen: diese allgemeinen Ticketverkaufsbedingungen der LatinMap.com Foundation<br/>b. Veranstaltung: die organisierte Veranstaltung, beispielsweise eine Veranstaltung musikalischer, kultureller, sportlicher und/oder freizeitlicher Art, für die die LatinMap.com Foundation Tickets verkauft<br/>c. Veranstalter: die natürliche oder juristische Person, die eine Veranstaltung produziert oder organisiert und dafür verantwortlich ist<br/>d. Kunde: die natürliche oder juristische Person, die mit der LatinMap.com Foundation einen Vertrag bezüglich einer Veranstaltung abschließt oder der die LatinMap.com Foundation ein entsprechendes Angebot unterbreitet<br/>e. Vertrag: die Vereinbarung zwischen der LatinMap.com Foundation und dem Kunden zum Erwerb von Tickets für Veranstaltungen<br/>f. Ticket: das Dokument, das als Eintrittskarte für eine Veranstaltung dient, einschließlich elektronischer Tickets</p><p>2. Anwendbarkeit</p><p>a. Diese Allgemeinen Geschäftsbedingungen gelten für alle Angebote, Bestellungen, Rechtsbeziehungen und Verträge, in denen die LatinMap.com Foundation Produkte oder Dienstleistungen jeglicher Art an den Kunden liefert, auch wenn diese Produkte oder Dienstleistungen in diesen Allgemeinen Geschäftsbedingungen nicht (weiter) beschrieben sind.<br/>b. Die LatinMap.com Foundation lehnt die Anwendbarkeit anderer Bedingungen des Kunden ausdrücklich ab.<br/>c. Abweichungen von den Allgemeinen Geschäftsbedingungen können die Parteien nur schriftlich vereinbaren. Die LatinMap.com Foundation ist berechtigt, die Allgemeinen Geschäftsbedingungen zu ändern und geänderte Allgemeine Geschäftsbedingungen für Verträge für anwendbar zu erklären. Die geänderten Allgemeinen Geschäftsbedingungen können auf der Website der LatinMap.com Foundation eingesehen werden. d. Der Vertrag unterliegt den Allgemeinen Geschäftsbedingungen des Veranstalters der Veranstaltung. Sofern diese dem Kunden noch nicht vorliegen, sendet der Veranstalter dem Kunden auf Anfrage die Allgemeinen Geschäftsbedingungen des Veranstalters zu.</p><p>3. Zustandekommen des Vertrags</p><p>a. Sofern nicht schriftlich etwas anderes vereinbart wurde, sind alle Angebote, einschließlich Anzeigen und Preislisten, wie auf der Website der LatinMap.com Foundation erwähnt, unverbindlich. b. Beim Anbieten und Verkaufen von Tickets fungiert die LatinMap.com Foundation als Vermittler bei der Entstehung des Vertrags zwischen Käufer und Veranstalter. Die LatinMap.com Foundation ist keine Partei des Vertrags, der durch den Kauf eines Tickets zustande kommt. Der Vertrag kommt zustande, nachdem der Kunde ein oder mehrere Tickets über die LatinMap.com Foundation gekauft hat. Die LatinMap.com Foundation stellt die Tickets im Namen des Veranstalters zur Verfügung.<br/>c. Vor der Bestätigung seiner Reservierung muss der Kunde immer überprüfen, ob die richtigen Tickets reserviert wurden. Bei der Reservierung muss der Kunde immer eine korrekte (E-Mail-)Adresse verwenden. Wenn der Kunde sich dafür entscheidet, Tickets elektronisch zu erhalten, liegt das Risiko des Verlusts, Diebstahls oder Missbrauchs des Tickets ab dem Zeitpunkt, an dem die Tickets ihn erreichen, beim Kunden. Wenn Zweifel an der Richtigkeit der vom Kunden bei der Bestellung eingegebenen Daten bestehen, kann die LatinMap.com Foundation den Kunden unter Verwendung der vom Kunden eingegebenen Daten kontaktieren. Wenn die LatinMap.com Foundation den Kunden nicht erreichen und die Daten daher nicht überprüfen kann, kann die LatinMap.com Foundation die Reservierung stornieren und die Tickets an einen anderen Kunden verkaufen. Wenn die LatinMap.com Foundation die Richtigkeit oder Gültigkeit der vom Kunden bei der Bestellung eingegebenen Daten oder der vom Kunden verwendeten Zahlungsmethode bezweifelt, hat sie das Recht, die Reservierung des Kunden zu stornieren und die Tickets an einen anderen Kunden zu verkaufen. Die LatinMap.com Foundation wird sich in einem solchen Fall bemühen, den Kunden zu informieren. Jeder Vertrag wird unter der aufschiebenden Bedingung der ausreichenden Verfügbarkeit der jeweiligen Produkte oder Dienstleistungen geschlossen.<br/>d. Die LatinMap.com Foundation und/oder der Veranstalter behalten sich das Recht vor, eine maximale Anzahl von Tickets festzulegen, die reserviert/gekauft werden können. Wenn diese Höchstzahl vom Kunden überschritten wird, sind die LatinMap.com Foundation und/oder der Veranstalter berechtigt, die Reservierung der Tickets über der Höchstzahl rückgängig zu machen oder die betreffenden Tickets für ungültig zu erklären.<br/>e. Tickets können nicht zurückgegeben werden. Für Tickets gilt die Bestimmung in Artikel 6:230p sub e BW.</p><p>4. Preise und Zahlung</p><p>a. Die LatinMap.com Foundation verkauft Tickets im Auftrag von Veranstaltern, die den Preis und die Anzahl der verfügbaren Plätze bestimmen. Informationen zu Preis und Verfügbarkeit sind unverbindlich und können sich ändern.<br/>b. Der Kunde zahlt für die über die Website bestellten Produkte oder Dienstleistungen den im Vertrag genannten Preis. Die Zahlung erfolgt auf die auf der Website der LatinMap.com Foundation angegebene Weise. Für die Bestellung können zusätzliche (Zahlungs-/Bestell-)Bedingungen gelten.</p><p>c. Alle auf der Website angegebenen Preise der LatinMap.com Foundation verstehen sich in Euro inklusive Mehrwertsteuer, sofern nicht ausdrücklich anders angegeben.<br/>d. Die LatinMap.com Foundation erhebt für jede Bestellung Servicegebühren. Darüber hinaus erhebt die LatinMap.com Foundation Verwaltungsgebühren, die auf der Grundlage des Gesamtbetrags der Transaktion berechnet werden.</p><p>e. Wenn der Kunde die fälligen Beträge nicht rechtzeitig bezahlt, ist er ohne Aufforderung oder Inverzugsetzung verpflichtet, die gesetzlichen Zinsen auf den ausstehenden Betrag zu zahlen. Wenn der Kunde nach einer Mahnung oder Inverzugsetzung mit der Begleichung der Forderung nachlässt, kann die LatinMap.com Foundation die Forderung abtreten. In diesem Fall ist der Kunde außerdem verpflichtet, alle gerichtlichen und außergerichtlichen Kosten zu erstatten, einschließlich der von externen Experten berechneten Kosten zusätzlich zu den gesetzlich festgelegten Kosten.</p><p>5. Lieferzeiten</p><p>a. Tickets werden an die (E-Mail-)Adresse gesendet, die der Kunde bei der Bestellung angegeben hat. Die LatinMap.com Foundation betrachtet die vom Kunden angegebene (E-Mail-)Adresse weiterhin als korrekt, bis der Kunde der LatinMap.com Foundation eine neue (E-Mail-)Adresse mitteilt. b. Die von der LatinMap.com Foundation angegebenen Lieferzeiten gelten nie als verbindliche Frist, sofern nicht ausdrücklich etwas anderes vereinbart wurde. Im Falle einer nicht rechtzeitigen Lieferung muss die LatinMap.com Foundation schriftlich in Verzug gesetzt werden.</p><p>c. Das Überschreiten einer Lieferzeit berechtigt den Kunden weder zu einer Entschädigung noch zum Stornieren der Bestellung oder zur Auflösung des Vertrags, es sei denn, die Lieferzeit wurde in einem solchen Ausmaß überschritten, dass vom Kunden eine Aufrechterhaltung des Vertrags nicht mehr zu erwarten ist.</p><p>d. Mit Ausnahme der Möglichkeit, elektronische Tickets zu bestellen, wird der Ticketverkauf über die Website und das Callcenter 8 Tage vor dem Veranstaltungsdatum eingestellt, um der LatinMap.com Foundation die Möglichkeit zu geben, die Tickets noch per Post zu versenden.</p><p> 6. Abgesagte und verschobene Veranstaltungen</p><p> a. Es liegt in der Verantwortung des Kunden, zu prüfen, ob eine Veranstaltung abgesagt oder verschoben wurde und wie die neue Uhrzeit oder der neue Ort sein werden. Obwohl Stichting LatinMap.com versucht, den Kunden über die Absage zu informieren, nachdem sie die erforderlichen Informationen vom Veranstalter erhalten hat, kann Stichting LatinMap.com nicht garantieren, dass der Kunde vor dem Veranstaltungsdatum über die Absage informiert wird.</p><p> b. Stichting LatinMap.com ist nicht für anfallende Kosten verantwortlich.<br/>c. Tickets für verschobene Veranstaltungen behalten grundsätzlich ihre Gültigkeit für die Ersatzveranstaltung. Für weitere Informationen hierzu kann der Kunde Stichting LatinMap.com über unsere E-Mail-Adresse mail(at)LatinMap.com kontaktieren. Wenn eine Veranstaltung an einen anderen Ort oder an ein anderes Datum verschoben wird, kann der Veranstalter Bedingungen für die Rückerstattung des Ticketpreises festlegen.<br/>d. Wenn eine Veranstaltung abgesagt oder verschoben wird, kann der Kunde die Tickets für diese Veranstaltung gemäß der vom Veranstalter festgelegten Regelung zurückgeben. Die entsprechenden Bedingungen entnehmen Sie bitte den Allgemeinen Geschäftsbedingungen des Veranstalters. Wenn der Veranstalter Stichting LatinMap.com auffordert, dem Kunden den Ticketpreis zu erstatten, wird Stichting LatinMap.com dies tun, nachdem der Veranstalter die entsprechenden Mittel erhalten hat. Service- und Verwaltungsgebühren werden nicht erstattet.</p><p> 7. Tickets </p><p> a. Die von Stichting LatinMap.com vertriebenen Tickets bleiben Eigentum des Veranstalters. Dem Kunden ist es nicht gestattet, ein Ticket weiterzuverkaufen, wenn dies gegen das Gesetz verstößt. Darüber hinaus kann ein Veranstalter den Weiterverkauf oder die gewerbliche Nutzung eines Tickets verbieten. Der Kunde sollte dies in den Allgemeinen Geschäftsbedingungen des Veranstalters überprüfen, auf die auf dem Ticket (und während des Bestellvorgangs) verwiesen wird. Im Falle eines (versuchten) Weiterverkaufs oder einer gewerblichen Nutzung unter Verstoß gegen das Gesetz oder die Bedingungen des Veranstalters ist der Veranstalter berechtigt, das betreffende Ticket für ungültig zu erklären und/oder dem Kunden eine Geldstrafe aufzuerlegen. Inhabern ungültiger Zugangsausweise wird der Zugang zur Veranstaltung verweigert, ohne dass ein Anspruch auf Entschädigung besteht.<br/>b. Nach Erhalt muss der Kunde die Tickets überprüfen, da Fehler nicht immer korrigiert werden können. Nach dem Kauf können Tickets nicht umgetauscht oder erstattet werden.<br/>c. Wenn das Ticket des Kunden so beschädigt ist, dass seine Echtheit nicht mehr überprüft werden kann, kann der Kunde den Online-Kundenservice kontaktieren.<br/>d. Sonderwünsche, wie die Reservierung von Rollstuhlplätzen, müssen rechtzeitig und ausdrücklich mitgeteilt werden. Stichting LatinMap.com kann nicht garantieren, dass Sonderwünsche berücksichtigt werden können. Für weitere Informationen hierzu kann der Kunde Stichting LatinMap.com über unsere E-Mail-Adresse kontaktieren: mail(at)LatinMap.com </p><p> 8. Geistige und gewerbliche Eigentumsrechte </p><p> a. Die gewerblichen und geistigen Eigentumsrechte, die auf dem Ticket von Stichting LatinMap.com ruhen, gehören Stichting LatinMap.com oder ihrem Lizenzgeber. Der Kunde wird alle Handlungen unterlassen, die die Rechte oder andere Interessen von Stichting LatinMap.com oder ihrem Lizenzgeber verletzen könnten.<br/>b. Dem Kunden ist es nicht gestattet, Hinweise auf Urheberrechte, Marken, Handelsnamen oder andere geistige oder gewerbliche Eigentumsrechte vom Ticket zu entfernen oder zu verändern, noch Änderungen an der Form oder anderen Merkmalen des Tickets vorzunehmen.<br/>c. Dem Kunden ist es untersagt, das Ticket in irgendeiner Weise zu fälschen, zu duplizieren oder zu reproduzieren.<br/>d. Die Vereinbarung erstreckt sich nicht auf die Übertragung geistiger Eigentumsrechte von Stichting LatinMap.com auf den Kunden. </p><p> 9. Datenschutz </p><p> a. Die vom Kunden beim Kauf von Tickets angegebenen Daten werden von Stichting LatinMap.com ausschließlich zur Verbesserung seiner Dienste verwendet.<br/>b. Die vom Kunden beim Kauf von Tickets angegebenen Daten werden niemals an Dritte weitergegeben. </p><p> c. Die vom Kunden beim Kauf von Tickets angegebenen Daten stehen der verkaufenden Organisation zur Verfügung. Es ist möglich, dass die Organisation die Daten zum Versenden von Mailings verwendet.<br/>d. Wir erwarten von unseren Kunden, dass sie mit diesen Informationen sorgfältig umgehen. Sollte dies nicht der Fall sein, würden wir dies gerne erfahren und den betreffenden Kunden informieren und ihn, sofern wir es für notwendig erachten, vom Online-Ticketverkauf ausschließen. </p><p> e. Hinweis: Für die Datenschutzbestimmungen unserer Kunden übernehmen wir keine Haftung. </p><p> 10. Haftung </p><p> a. Stichting LatinMap.com kann nicht als Veranstalter (Veranstalter) der Veranstaltung betrachtet werden und ist nicht verantwortlich oder garantiert für die (künstlerische) Qualität und den Inhalt der Veranstaltung und den Ablauf der Veranstaltungen in oder um die Veranstaltung herum und übernimmt auf dieser Grundlage keine Haftung. </p><p> b. Abgesehen von den anderen Haftungsbestimmungen in diesen Allgemeinen Geschäftsbedingungen ist die Gesamthaftung von Stichting LatinMap.com aufgrund zurechenbarer Nichterfüllung oder aufgrund einer unerlaubten Handlung auf den Ersatz direkter Schäden bis zu höchstens dem Betrag beschränkt, der dem Kunden für die Tickets in Rechnung gestellt wurde oder werden kann, es sei denn, der Schaden ist das Ergebnis von Vorsatz und/oder grober Fahrlässigkeit von </p><p> Stichting LatinMap.com oder ihren Untergebenen.<br/> c. Die Haftung von Stichting LatinMap.com aufgrund einer zurechenbaren Nichterfüllung eines Vertrags entsteht in allen Fällen nur, wenn der Kunde Stichting LatinMap.com unverzüglich und ordnungsgemäß schriftlich in Verzug setzt, eine angemessene Frist zur Behebung des Verzugs setzt und Stichting LatinMap.com auch nach Ablauf dieser Frist weiterhin zurechenbar in Verzug ist. Die Inverzugsetzung muss eine möglichst vollständige und detaillierte Beschreibung des Verzugs enthalten, damit Stichting LatinMap.com angemessen reagieren kann.<br/> d. Der Kunde stellt Stichting LatinMap.com von allen Ansprüchen Dritter frei, die sich auf die Nichterfüllung oder mangelhafte Erfüllung einer Verpflichtung des Kunden gegenüber Stichting LatinMap.com beziehen, unabhängig davon, ob diese sich aus den Allgemeinen Geschäftsbedingungen ergibt oder nicht.<br/> e. Voraussetzung für das Bestehen eines Anspruchs auf Entschädigung ist immer, dass der Kunde den Schaden Stichting LatinMap.com so schnell wie möglich nach seinem Auftreten schriftlich meldet. f. Stichting LatinMap.com kann niemals für Schäden oder Verluste des Tickets haftbar gemacht werden. Bei Verlust oder Diebstahl hat der Kunde keinen Anspruch auf ein Ersatzticket oder die Erstattung etwaiger Geldbeträge. Stichting LatinMap.com haftet außerdem nicht für Verspätungen oder die Nichtlieferung oder falsche Lieferung von Tickets, wenn die Verspätung oder Nichtlieferung oder falsche Lieferung nicht Stichting LatinMap.com zugeschrieben werden kann.<br/> g. Stichting LatinMap.com übernimmt keinerlei Haftung für Tickets, die der Kunde von Dritten erhalten hat. Stichting LatinMap.com kann deren Echtheit auch nicht garantieren.<br/> h. Stichting LatinMap.com kann in keiner Weise für Schäden haftbar gemacht werden, die dem Inhaber dieser Eintrittskarte durch Handlungen oder Unterlassungen Dritter entstehen. </p><p> 11. Höhere Gewalt </p><p> a. Unter höherer Gewalt wird jedes Versäumnis verstanden, das Stichting LatinMap.com nicht zugeschrieben werden kann, weil es nicht auf ihr Verschulden zurückzuführen ist und weder nach dem Gesetz, Rechtsakt noch nach allgemein anerkannten Standards zu ihr gehört.<br/> b. Unbeschadet ihrer sonstigen Rechte hat Stichting LatinMap.com das Recht, die Ausführung der Bestellung des Kunden im Falle höherer Gewalt durch schriftliche Mitteilung an den Kunden auszusetzen, ohne dass Stichting LatinMap.com zu irgendeiner Entschädigung verpflichtet ist, es sei denn, dies wäre unter den gegebenen Umständen nach Maßstäben der Angemessenheit und Billigkeit unannehmbar.</p><p> 12. Geltendes Recht und Gerichtsstand </p><p> a. Alle Verträge mit Stichting LatinMap.com unterliegen niederländischem Recht. </p><p> 13. Verschiedenes </p><p> a. Kunden, die zu spät zur Veranstaltung kommen, werden – soweit möglich – zu geeigneten Zeitpunkten während der Veranstaltung eingelassen. Der Einlass kann jedoch nicht garantiert werden.<br/> b. Wenn diese Allgemeinen Geschäftsbedingungen Stichting LatinMap.com zu einer schriftlichen Mitteilung verpflichten, ist Stichting LatinMap.com berechtigt, diese Mitteilung elektronisch zu machen, beispielsweise, aber nicht beschränkt auf, eine E-Mail-Nachricht oder ein Fax.<br/> c. Offensichtliche Irrtümer und Tippfehler auf der Website von Stichting LatinMap.com oder in Angeboten, Auftragsbestätigungen, Tickets und/oder anderen Dokumenten binden Stichting LatinMap.com nicht. d. Im Falle einer Meinungsverschiedenheit zwischen Stichting LatinMap.com und dem Kunden bezüglich der Übersetzung und/oder Auslegung der Allgemeinen Geschäftsbedingungen ist die niederländische Version maßgeblich.<br/> e. Sollten eine oder mehrere Bestimmungen dieser Allgemeinen Geschäftsbedingungen oder einer anderen Vereinbarung mit Stichting LatinMap.com im Widerspruch zu geltenden gesetzlichen Bestimmungen stehen, ist die betreffende Bestimmung ungültig und wird durch eine neue, gesetzlich zulässige und vergleichbare Bestimmung ersetzt, die von Stichting LatinMap.com festgelegt wird. </p>'
        },
        'privacy-policy': {
            title: 'Datenschutzrichtlinie',
            body: '<p> Datenschutzrichtlinie für latinmap.com: Entdecken und erleben Sie die lateinische Tanzwelt <br>> Zuletzt aktualisiert: 23-05-2023 <br> Vielen Dank für den Besuch von latinmap.com, dem Ziel, die lateinische Tanzwelt zu entdecken und zu erleben.'
        },
        about: {
            'about-latin-scene': {
                title: "über lateinische Szene",
                body: "Die lateinische Tanzszene ist eine lebendige und vielfältige Gemeinschaft, die das reiche kulturelle Erbe Lateinamerikas durch Musik, Tanz und Kunst feiert."
            },
            salsa: {
                title: "Salsa",
                body: "Salsa ist eine beliebte Form des sozialen Tanzes, die aus der Karibik stammt."
            },
            bachata: {
                title: "Bachata",
                body: "Bachata ist ein Genre der lateinamerikanischen Musik, das in der ersten Hälfte des 20. Jahrhunderts mit europäischen, indigenen und afrikanischen musikalischen Elementen aus der Dominikanischen Republik stammt."
            },
            zouk: {
                title: "Zouk",
                body: "Zouk ist ein schneller Jump-up-Karneval-Beat-Stil rhythmischer Musik, der aus den karibischen Inseln Guadeloupe und Martinique stammt und in den 1980er Jahren von den französischen Antilles Kassav populär gemacht wurde."
            },
            kizomba: {
                title: "Kizomba",
                body: "Kizomba ist ein Musikgenre und einen Tanzstil, der in den späten 1970er und frühen 1980er Jahren aus Angola stammt."
            },
            cuban: {
                title: "Kubaner",
                body: "Kubanische Musik und Tanz sind tief im vielfältigen kulturellen Erbe der Insel verwurzelt, das afrikanische, spanische und indigene Einflüsse verbindet."
            }
        },
        'help-center-faq': {
            title: 'Hilfezentrum',
        },
        'cookie-policy': {
            title: 'Cookie-Richtlinie',
        },
        'create-an-event': {
            title: 'So erstellen Sie eine Veranstaltung',
        },
        'create-an-brand-or-an-organization': {
            title: 'So erstellen Sie eine Marke',
        },
        'become-an-ambassador': {
            title: 'Werde ein Botschafter',
        },
        'promote-your-event': {
            title: 'Bewerben Sie Ihre Veranstaltung',
        },
        'professional-account-verification': {
            title: 'Professionelle Kontoüberprüfung'
        },
        'about-us': {
            title: 'Über uns',
        },
    },
    email: {
        'not-unique': 'Die E -Mail wurde bereits angenommen.',
    },
    leads: {
        title: 'LEIN einreichen',
        description_p1: 'Sind Sie LatinMap-Benutzer und haben Sie eine Tanzschule, Organisation oder Veranstaltung gefunden, die noch nicht aufgeführt ist? Reichen Sie es hier ein — Ihr Beitrag hilft uns, die Plattform vollständig, genau und wertvoll für Tänzer weltweit zu halten.',
        description_p2: 'Sind Sie ein Organisator und möchten auf LatinMap gelistet werden? Erstellen Sie ein Pro-Konto und fügen Sie Ihre Aktivitäten kostenlos zur Plattform hinzu!',
        description_p3: 'Vielen Dank, dass Sie uns helfen, LatinMap zu erweitern, die Plattform, die die globale Tanzgemeinschaft verbindet.',
        plural: 'Leads',
        type: {
            event: 'Ereignis',
            organization: 'Organisation',
            label: 'Typ',
        },
        name: 'Name',
        address: 'Adresse',
        country: 'Land',
        city: 'Stadt',
        street: 'Straße',
        street_number: 'Straßennummer',
        dance_styles: 'Tanzstile',
        music_styles: 'Musikstile',
        photos: 'Fotos',
        category: 'Ereignisart',
        location_name: 'Veranstaltungsort Name',
        location_type: {
            singular: 'Standorttyp',
            online: 'virtuell',
            offline: 'persönlich',
        },
        timezone: 'Zeitzone',
        date: 'Datum',
        not_posted_by_ambassador: 'vom Organisator verifiziert',
        undercondition: 'Unterzustand',
        warning: 'Wichtige Veränderung',
        cancelled: 'abgesagt',
        posted_by_ambassador: 'Gepostet von latinmap Botschafter',
        upcoming: 'bevorstehende Veranstaltungen',
        status_options: {
            active: 'aktiv',
            canceled: 'abgesagt',
            pending: 'Noch nicht bestätigt',
            changed: 'Wichtige Veränderung',
            submitted: 'eingereicht',
            under_review: 'in Überprüfung',
            implemented: 'implementiert',
            declined: 'abgelehnt',
        },
        submit: 'einreichen',
        success: 'Die Führung wurde eingereicht.',
        filter_type: 'Filter nach Typ',
        view: 'führen',
        confirm_delete: 'Führung löschen',
        delete_confirmation: 'Sind Sie sicher, dass Sie diesen Vorsprung löschen möchten?',
        deleted_successfully: 'Die Führung wurde erfolgreich gelöscht.',
        error_loading: 'Fehlerladeladungen',
        status_updated: 'Der Lead -Status wurde aktualisiert.',
        error_status: 'Fehler Aktualisierung des Lead -Status',
    },
    search: {
        allOragnisations: 'Alle Tanzschulen ansehen',
        allEvents: 'Alle Ereignisse anzeigen',
        searchresult: 'Suchergebnisse',
        type: 'Typ',
        title: 'Titel',
        city: 'Stadt',
        country: 'Land',
        address: 'Adresse',
        startdate: 'Startdatum',
        favorite: 'Favoritin'
    },
    components: {
        picture_input: {
            drag: "Laden Sie Avatar hoch",
            remove: 'Avatar löschen',
            change_avatar: 'Avatar ändern'
        },
        pictureInput: {
            drag: "Klicken Sie hier, um das Bild hochzuladen",
            change: "Ändern",
            remove: "Entfernen",
            upload: "Hochladen",
            tap: "Zum Hochladen tippen",
            select: "Datei auswählen",
            selected: "Ausgewählt",
            fileSize: "Dateigröße",
            fileType: "Dateityp",
            aspect: "Seitenverhältnis"
        },
    },
    passion: {
        title: "Spüre den Rhythmus, Werde Teil der Bewegung",
        subtitle: "Entdecke die lebendige Welt des Latin Dance. Verbinde dich mit Tänzern, finde Events in deiner Nähe und lass die Musik deine Seele bewegen.",
    },
    payment: {
        received: "Zahlung erhalten",
        thank_you: "Vielen Dank für Ihren Kauf!",
        download_ticket: "Download -Ticket (en) herunterladen",
        download_button: "Download -Ticket (en) herunterladen",
        email_check: "Bitte überprüfen Sie Ihren Posteingang, einschließlich des Spam -Ordners, eine E -Mail von unserem Ticketing -System.",
        failed: "Zahlung anhängig",
        failed_message: "Leider haben wir eine Ausgabe gestoßen, die Ihre Zahlung bearbeitet.",
        download_invoice: "Rechnung herunterladen",
        download_invoice_button: "Rechnung herunterladen",
        invoice_check: "Bitte überprüfen Sie Ihren Posteingang auf Ihre Rechnung.",
        thank_you_for_purchase: "Vielen Dank für den Kauf der vorgestellten Veranstaltung!",
    },
    financial_center: {
        financial_dashboard: 'Mein finanzielles Dashboard',
        title: "Finanzzentrum",
        description: "Verwalten Sie Ihre Transaktionen, Auszahlungen, Werbeaktionen und Premium -Funktionen.",
        overview: "Überblick",
        transactions: "Transaktionen",
        payoutsettings: "Auszahlungseinstellungen",
        featured_events: "Ausgewählte Veranstaltungen",
        ticketsales: "Ticketverkauf",
        premium: "Premium -Konten",
    },
    inputfield: {
        select_here: 'Wählen Sie hier aus',
    },
    tooltip: {
        edit: 'Bearbeiten',
        delete: 'Löschen',
        view: 'Ansehen',
        hide: 'Ausblenden',
        under_construction: 'Im Bau',
    },
    // LA-157: where someone stops the automated emails LatinMap sends.
    email_preferences: {
        error: "Etwas ist schiefgelaufen. Bitte versuche es gleich noch einmal.",
        confirm: {
            title: "Keine E-Mails mehr?",
            body: "Du erhältst diese automatischen E-Mails derzeit an {email}.",
            note: "Nachrichten zu deinem Konto, etwa zum Zurücksetzen des Passworts, senden wir weiterhin.",
            button: "Diese E-Mails stoppen",
        },
        done: {
            title: "Du erhältst nichts mehr",
            body: "Wir senden keine automatischen E-Mails mehr an {email}.",
            undo: "Doch wieder erhalten",
        },
        unknown: {
            title: "Dieser Link funktioniert nicht mehr",
            body: "Der Link ist ungültig. Nutze den Link aus einer neueren E-Mail.",
        },
    },
    // LA-194: the public page an organiser reaches through a submission link.
    submit_event: {
        eyebrow: 'Event einreichen',
        title: 'Sende dein Event an LatinMap',
        title_brand: 'Ein Event für {brand} einreichen',
        lede: 'Trage ein, was du weißt. Wir bereiten es vor und veröffentlichen es nach einer kurzen Prüfung.',
        loading: 'Einen Moment…',
        notes: {
            no_account: 'Kein Konto nötig — dieser Link genügt',
            checked: 'Wir prüfen jedes Event, bevor es online geht',
            reply: 'Bei Unklarheiten melden wir uns per E-Mail',
        },
        sections: {
            event: 'Das Event',
            where: 'Wo',
            details: 'Details',
            you: 'Über dich',
        },
        fields: {
            name: 'Name des Events',
            organizer_name: 'Name des Veranstalters / der Marke',
            organizer_url: 'Website oder Social-Media-Link des Veranstalters',
            start_date: 'Datum',
            start_time: 'Beginn',
            end_date: 'Enddatum',
            end_time: 'Ende',
            dance_styles: 'Tanzstile',
            event_category: "Art des Events",
            event_category_placeholder: "Art des Events wählen",
            location_name: 'Veranstaltungsort',
            city: 'Stadt',
            country: 'Land',
            country_placeholder: 'Land wählen',
            short_description: 'Kurzbeschreibung',
            description: 'Ausführliche Beschreibung',
            link: 'Link zu Infos oder Tickets',
            photo: "Foto",
            photo_remove: "Foto entfernen",
            your_name: 'Dein Name',
            your_email: 'Deine E-Mail-Adresse',
        },
        hints: {
            organizer:
                'Wer veranstaltet dieses Event? Ein Link zur Website oder zu Instagram hilft uns, die richtige Marke zu finden.',
            end_date: "Bei einem eintägigen Event ist das dasselbe Datum wie der Beginn.",
            contact: 'Wir nutzen das nur, um dich zu diesem Event zu erreichen.',
            photo: "Optional. JPG, PNG oder WebP, maximal 8 MB.",
        },
        errors: {
            name: 'Bitte gib den Namen des Events an.',
            start_date: 'Bitte gib das Datum an.',
            end_date: "Bitte gib das Enddatum an.",
            event_category: "Bitte wähle eine Art des Events.",
            too_many: "Du hast es zu oft versucht. Warte einen Moment und versuche es erneut.",
            city: 'Bitte gib die Stadt an.',
            country: 'Bitte wähle ein Land.',
            organizer_name: 'Bitte gib an, wer dieses Event veranstaltet.',
            email: 'Bitte gib eine gültige E-Mail-Adresse an.',
            failed: 'Das Senden hat nicht geklappt. Bitte versuche es gleich noch einmal.',
            photo_type: "Bitte wähle ein JPG, PNG oder WebP.",
            photo_size: "Dieses Foto ist zu groß. Maximal 8 MB.",
        },
        submit: 'Event einreichen',
        done: {
            title: 'Danke, wir haben dein Event',
            body: 'Jemand von LatinMap schaut es sich an. Du bekommst eine Bestätigung per E-Mail.',
            again: 'Noch ein Event einreichen',
        },
        invalid: {
            title: 'Dieser Link funktioniert nicht mehr',
            body: 'Der Link ist abgelaufen oder zurückgezogen. Bitte frage nach einem neuen.',
        },
    },
    // LA-180: the screen Brevo returns to after a subscription is
    // confirmed. Top-level rather than under footer, because the same
    // confirmation ends both the footer form and the signup opt-in.
    newsletter: {
        // LA-176: the fixed sign-up landing page behind every QR code,
        // social bio and e-mail signature.
        stay_updated: {
            title: 'Bleib nah an der Szene',
            lede: 'Erhalte die Latin-Dance-Veranstaltungen, für die du dir den Abend freihältst — Partys, Festivals, Workshops und Schnupperstunden, dazu neue Funktionen und Verlosungen von LatinMap.',
            benefits: {
                agenda: 'Der Kalender, früher als alle anderen',
                festivals: 'Festivals und Kongresse, für die sich die Reise lohnt',
                features: 'Neue LatinMap-Funktionen, sobald es sie gibt',
                community: 'Verlosungen und Neuigkeiten aus der Community',
            },
            form_title: 'Anmelden',
            email_label: 'Deine E-Mail-Adresse',
            submit: 'Auf die Liste setzen',
            terms: 'Immer nur eine E-Mail, und deine Adresse geht nie an Dritte. Abmelden mit einem Klick, in jeder Nachricht.',
            done: {
                title: 'Schau in dein Postfach',
                body: 'Wir haben dir eine E-Mail geschickt. Klicke auf den Link darin, dann stehst du auf der Liste.',
                again: 'Weitere Adresse anmelden',
            },
        },
        confirmed: {
            title: 'Anmeldung bestätigt',
            success: 'Deine Anmeldung ist bestätigt. Willkommen!',
            body: 'Du erhältst ab jetzt den LatinMap-Newsletter: die besten Latin-Dance-Veranstaltungen direkt in dein Postfach. Abmelden kannst du dich mit einem Klick in jedem Newsletter.',
            discover_events: 'Veranstaltungen entdecken',
            back_home: 'Zurück zur Startseite',
        },
    },
    footer: {
        section_1: {
            title: 'Discover LatinMap',
            about: 'Über uns',
            how_it_works: 'Wie es funktioniert',
            search: 'Suchen',
            contact: 'Kontakt',
        },
        section_2: {
            title: 'Support und Community',
            help: 'Hilfezentrum und FAQ',
            privacy_policy: 'Datenschutzrichtlinie',
            terms_and_conditions: 'Allgemeine Geschäftsbedingungen',
            cookie_policy: 'Cookie -Richtlinie',
        },
        section_3: {
            title: 'Für Profis',
            create_event: 'So erstellen Sie eine Veranstaltung',
            create_organization: 'So erstellen Sie eine Marke',
            become_ambassador: 'Werden Sie ein Botschafter',
            promote_event: 'So fördern Sie Ihre Veranstaltung',
            professional_account_verification: 'Professionelle Kontoüberprüfung'
        },
        section_4: {
            title: 'Tanz- & Eventkategorien',
            all_events: 'Alle Veranstaltungen',
        },
        follow_our_socials: 'Folgen Sie unseren sozialen Medien',
    }
};
